import { gql } from "@apollo/client";
import { isTemplatesV2 } from "../../constant/TemplateConstant";

export const CREATE_COMPANY = gql`
  mutation CreateCompany(
    $name: String!
    $phone: String
    $address: String
    $city: String
    $state: String
    $postalCode: String
    $country: String
    $timezone: String
    $locationLink: String
    $isOptinConsentMethod: Boolean
    $isOpenCrmWarningPopup: Boolean
    $profilePic: String
    $website: String
    $isPushToCrm: Boolean
    $isPushToDms: Boolean
  ) {
    createCompany(
      name: $name
      phone: $phone
      address: $address
      city: $city
      state: $state
      postalCode: $postalCode
      country: $country
      timezone: $timezone
      locationLink: $locationLink
      isOptinConsentMethod: $isOptinConsentMethod
      isOpenCrmWarningPopup: $isOpenCrmWarningPopup
      profilePic: $profilePic
      website: $website
      isPushToCrm: $isPushToCrm
      isPushToDms: $isPushToDms
    ) {
      company {
        id
        name
        phone
        address
        city
        state
        postalCode
        country
        timezone
        locationLink
        isGlobalCrm
        isOpenCrmWarningPopup
        profilePic
        website
        isOptinConsentMethod
        isPushToCrm
        isPushToDms
      }
    }
  }
`;

export const UPDATE_COMPANY = gql`
  mutation UPDATECompany(
    $id: Int!
    $name: String!
    $phone: String
    $address: String
    $city: String
    $state: String
    $postalCode: String
    $country: String
    $industry: String
    $website: String
    $addressDetail: String
    $isDisabled: Boolean
    $automaticEngagement: Boolean
    $timezone: String
    $locationLink: String
    $isOptinConsentMethod: Boolean
    $isOpenCrmWarningPopup: Boolean
    $profilePic: String
    $isPushToCrm: Boolean
    $isPushToDms: Boolean
  ) {
    updateCompany(
      id: $id
      name: $name
      phone: $phone
      address: $address
      city: $city
      state: $state
      postalCode: $postalCode
      country: $country
      industry: $industry
      website: $website
      addressDetail: $addressDetail
      isDisabled: $isDisabled
      automaticEngagement: $automaticEngagement
      timezone: $timezone
      locationLink: $locationLink
      isOptinConsentMethod: $isOptinConsentMethod
      isOpenCrmWarningPopup: $isOpenCrmWarningPopup
      profilePic: $profilePic
      isPushToCrm: $isPushToCrm
      isPushToDms: $isPushToDms
    ) {
      ok
      company {
        id
        name
        phone
        address
        city
        state
        postalCode
        country
        website
        industry
        addressDetail
        isDisabled
        dateCreated
        userCount
        automaticEngagement
        timezone
        locationLink
        isOptinConsentMethod
        isGlobalCrm
        isOpenCrmWarningPopup
        profilePic
        isPushToCrm
        isPushToDms
      }
    }
  }
`;
export const GET_REFRESH_TOKEN = gql`
  mutation generateAccessToken($refreshToken: String!) {
    generateAccessToken(refreshToken: $refreshToken) {
      statusCode
      message
      accessToken
    }
  }
`;
export const ADD_USER = gql`
  mutation CreateUser(
    $email: String!
    $firstName: String!
    $lastName: String!
    $companyId: Int
    $roleId: Int
    $phone: String
    $locationId: Int!
    $locationIds: [Int]
    $companyRoleId: Int
    $departmentIds: [Int]
    $settings: GenericScalar
    $dsUser: DsUserInput
  ) {
    createUser(
      email: $email
      firstName: $firstName
      lastName: $lastName
      companyId: $companyId
      roleId: $roleId
      phone: $phone
      locationId: $locationId
      locationIds: $locationIds
      companyRoleId: $companyRoleId
      departmentIds: $departmentIds
      settings: $settings
      dsUser: $dsUser
    ) {
      statusCode
      message
      user {
        id
        email
        fullName
        phone
        companyRoleId
        settings
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser(
    $userId: Int!
    $firstName: String!
    $lastName: String!
    $email: String
    $isTranslationEnabled: Boolean
    $oldPass: String
    $newPass: String
    $roleId: Int
    $companyId: Int
    $phone: String
    $locationId: Int
    $locationIds: [Int]
    $companyRoleId: Int
    $permissionActionIds: [Int]
    $profilePic: String
    $preferredLanguageCode: String
    $departmentIds: [Int]
    $settings: GenericScalar
    $dsUser: DsUserInput
    $permissionActionLocationObjs: [PermissionActionLocationObj]
  ) {
    updateUser(
      userId: $userId
      firstName: $firstName
      lastName: $lastName
      email: $email
      isTranslationEnabled: $isTranslationEnabled
      oldPass: $oldPass
      newPass: $newPass
      roleId: $roleId
      companyId: $companyId
      phone: $phone
      locationId: $locationId
      locationIds: $locationIds
      companyRoleId: $companyRoleId
      permissionActionIds: $permissionActionIds
      profilePic: $profilePic
      preferredLanguageCode: $preferredLanguageCode
      departmentIds: $departmentIds
      settings: $settings
      dsUser: $dsUser
      permissionActionLocationObjs: $permissionActionLocationObjs
    ) {
      statusCode
      message
      user {
        companyId
        id
        cognitoId
        firstName
        lastName
        fullName
        email
        isDisabled
        dateCreated
        locationId
        settings
        userRoles {
          id
          companyId
          roleId
          role {
            id
            name
          }
          company {
            id
            name
            timezone
            locationLink
            isOptinConsentMethod
            isGlobalCrm
          }
        }
        status
        phone
        companyRoleId
        companyRole {
          id
          name
          locations {
            locationId
            location {
              id
              title
            }
          }
        }
        userAccounts {
          id
          userId
          companyId
          isDisabled
          company {
            id
            isGlobalCrm
          }
        }
        role {
          id
          name
          canViewAutoAnalytics
          canViewAdExport
        }
        location {
          id
          title
        }
        locations {
          id
          userId
          locationId
          location {
            id
            title
          }
          isPrimary
        }
        departmentIds
        dsUsers {
          id
          dsUserId
          dsUserName
          active
        }
      }
    }
  }
`;

export const UPDATE_USER_FILTERS = gql`
  mutation UpdateUserFilters(
    $filters: [FilterInputs]!
    $userId: Int
    $setType: String
    $isDynamicFilter: Boolean
    $isRemoved: Boolean
  ) {
    updateUserFilters(
      filters: $filters
      userId: $userId
      setType: $setType
      isDynamicFilter: $isDynamicFilter
      isRemoved: $isRemoved
    ) {
      userFilters {
        id
        value
        type
        typeName
        companyFilterId
        filterType {
          isDynamic
        }
      }
    }
  }
`;
export const CREATE_USAGE_EVENT = gql`
  mutation CreateUsageEvent($verb: String!, $context: String, $duration: Float!, $eventId: Int) {
    createUsageEvent(verb: $verb, context: $context, duration: $duration, eventId: $eventId) {
      event {
        id
        timestamp
        verb
        subjectId
        context
        duration
      }
    }
  }
`;

export const SAVE_USER_FILTER_SET = gql`
  mutation SaveUserFilterSet($name: String!, $setType: String!) {
    saveUserFilterSet(name: $name, setType: $setType) {
      filterSet {
        id
        userId
        name
        setType
      }
    }
  }
`;

export const UPDATE_USER_FILTER_SET = gql`
  mutation UpdateUserFilterSet($delete: Boolean, $id: Int!, $name: String!, $setType: String!) {
    updateUserFilterSet(delete: $delete, id: $id, name: $name, setType: $setType) {
      ok
    }
  }
`;

export const SELECT_FILTER_SET = gql`
  mutation SelectFilterSet($id: Int!, $setType: String!) {
    selectFilterSet(filterSetId: $id, setType: $setType) {
      userFilters {
        type
        typeName
        value
        companyFilterId
        id
        setType
      }
    }
  }
`;

export const PROSPECT_ACTION = gql`
  mutation ProspectAction($action: String!, $id: Int!, $postType: String) {
    prospectAction(action: $action, aingineDataId: $id, postType: $postType) {
      ok
    }
  }
`;

export const UPDATE_DEAL = gql`
  mutation UpdateDeal(
    $email: String
    $firstName: String
    $followupDate: DateTime
    $id: Int!
    $lastName: String
    $location: String
    $phone: String
    $status: String
    $strength: String
    $userId: Int
    $allowNotifications: Boolean
  ) {
    updateDeal(
      email: $email
      firstName: $firstName
      followupDate: $followupDate
      id: $id
      lastName: $lastName
      location: $location
      phone: $phone
      status: $status
      strength: $strength
      userId: $userId
      allowNotifications: $allowNotifications
    ) {
      ok
      deal {
        id
        userId
        companyId
        aingineDataId
        screenName
        firstName
        lastName
        email
        phone
        location
        url
        profileUrl
        source
        strength
        status
        dateCreated
        followupDate
        subscribed
        allowNotifications
        tags
        conversations {
          id
          type
          message
          postTime
          aingineUserId
          aingineDataId
        }
      }
    }
  }
`;

export const ADD_COMMENT = gql`
  mutation AddDealComment($dealId: Int!, $message: String!) {
    addDealComment(dealId: $dealId, message: $message) {
      ok
      deal {
        id
        userId
        companyId
        aingineDataId
        screenName
        firstName
        lastName
        email
        phone
        location
        url
        profileUrl
        source
        strength
        status
        dateCreated
        followupDate
        conversations {
          id
          type
          message
          postTime
          aingineUserId
          aingineDataId
        }
      }
    }
  }
`;
export const SAVE_FILTER_TYPE = gql`
  mutation SaveFilterType($id: Int, $name: String!, $type: String!, $filterField: String!) {
    saveFilterType(id: $id, name: $name, type: $type, filterField: $filterField) {
      ok
      filterType {
        id
        name
        type
        filterField
        optionsCount
      }
    }
  }
`;

export const DELETE_FILTER_TYPE = gql`
  mutation DeleteFilterType($filterId: Int!) {
    deleteFilterType(filterId: $filterId) {
      ok
    }
  }
`;

export const SAVE_SELECTION_OPTION = gql`
  mutation SaveSelectionOption($filterTypeId: Int!, $value: String!, $query: String) {
    saveSelectionOption(filterTypeId: $filterTypeId, value: $value, query: $query) {
      ok
      selectionOption {
        id
        value
        query
      }
    }
  }
`;

export const REMOVE_SELECTION_OPTION = gql`
  mutation RemoveSelectionOption($id: Int!) {
    removeSelectionOption(id: $id) {
      ok
    }
  }
`;

export const SAVE_COMPANY_FILTERS = gql`
  mutation SaveCompanyFilters($filters: [CompanyFilterInput]!, $companyId: Int!) {
    saveCompanyFilters(filters: $filters, companyId: $companyId) {
      ok
      conflicts {
        id
        selectionOption {
          id
          value
          filterType {
            id
            name
          }
        }
      }
    }
  }
`;

export const SAVE_RESPONSE_TEMPLATE = gql`
  mutation SaveResponseTemplate(
    $id: Int
    $isInitialResponse: Boolean!
    $message: String!
    $userId: Int
  ) {
    saveResponseTemplate(
      id: $id
      isInitialResponse: $isInitialResponse
      message: $message
      userId: $userId
    ) {
      ok
      responseTemplate {
        id
        message
        isInitialResponse
      }
    }
  }
`;

export const DELETE_REPONSE_TEMPLATE = gql`
  mutation DeleteResponseTemplate($id: Int!, $userId: Int) {
    deleteResponseTemplate(id: $id, userId: $userId) {
      ok
    }
  }
`;

export const UPDATE_USER_DISABLED_STATUS = gql`
  mutation UpdateUserDisabledStatus($userId: Int!, $isDisabled: Boolean!) {
    updateUserDisabledStatus(userId: $userId, isDisabled: $isDisabled) {
      ok
    }
  }
`;
export const UPDATE_USER_DISABLED_COMPANY_STATUS = gql`
  mutation UpdateUserDisabledCompanyStatus($userId: Int!, $companyId: Int!, $isDisabled: Boolean!) {
    updateUserDisabledCompanyStatus(
      userId: $userId
      companyId: $companyId
      isDisabled: $isDisabled
    ) {
      ok
    }
  }
`;
export const CREATE_TEAM = gql`
  mutation createTeam(
    $companyId: Int!
    $name: String!
    $leaderId: Int!
    $locationId: Int!
    $members: [TeamMemberInputs]!
  ) {
    createTeam(
      companyId: $companyId
      name: $name
      leaderId: $leaderId
      locationId: $locationId
      members: $members
    ) {
      team {
        id
        name
        leaderId
        members {
          id
          memberId
        }
      }
    }
  }
`;

export const UPDATE_TEAM = gql`
  mutation updateTeam(
    $id: Int!
    $name: String!
    $status: String!
    $leaderId: Int!
    $locationId: Int!
    $members: [TeamMemberInputs]!
  ) {
    updateTeam(
      id: $id
      name: $name
      status: $status
      leaderId: $leaderId
      locationId: $locationId
      members: $members
    ) {
      team {
        id
        name
        leaderId
        members {
          id
          memberId
        }
      }
    }
  }
`;

export const DELETE_TEAM = gql`
  mutation deleteTeam($id: Int!) {
    deleteTeam(id: $id) {
      ok
    }
  }
`;

export const CREATE_ROLE = gql`
  mutation CreateRole(
    $companyId: Int
    $name: String!
    $canCreateUsers: Boolean!
    $canCreateTeams: Boolean!
    $canViewProspects: Boolean!
    $isCompanyAdmin: Boolean!
    $canViewAutoAnalytics: Boolean!
    $canViewAdExport: Boolean!
    $canViewClm: Boolean!
    $canViewGle: Boolean!
    $canViewEngagements: Boolean!
  ) {
    createRole(
      companyId: $companyId
      name: $name
      canCreateUsers: $canCreateUsers
      canCreateTeams: $canCreateTeams
      canViewProspects: $canViewProspects
      isCompanyAdmin: $isCompanyAdmin
      canViewAutoAnalytics: $canViewAutoAnalytics
      canViewAdExport: $canViewAdExport
      canViewClm: $canViewClm
      canViewGle: $canViewGle
      canViewEngagements: $canViewEngagements
    ) {
      ok
    }
  }
`;

export const EDIT_ROLE = gql`
  mutation EditRole(
    $companyId: Int
    $roleId: Int!
    $name: String!
    $canCreateUsers: Boolean!
    $canCreateTeams: Boolean!
    $canViewProspects: Boolean!
    $isCompanyAdmin: Boolean!
    $canViewAutoAnalytics: Boolean!
    $canViewAdExport: Boolean!
    $canViewClm: Boolean!
    $canViewGle: Boolean!
    $canViewEngagements: Boolean!
  ) {
    editRole(
      companyId: $companyId
      roleId: $roleId
      name: $name
      canCreateUsers: $canCreateUsers
      canCreateTeams: $canCreateTeams
      canViewProspects: $canViewProspects
      isCompanyAdmin: $isCompanyAdmin
      canViewAutoAnalytics: $canViewAutoAnalytics
      canViewAdExport: $canViewAdExport
      canViewClm: $canViewClm
      canViewGle: $canViewGle
      canViewEngagements: $canViewEngagements
    ) {
      ok
    }
  }
`;

export const DELETE_ROLE = gql`
  mutation DeleteRole($companyId: Int!, $roleId: Int!) {
    deleteRole(companyId: $companyId, roleId: $roleId) {
      ok
    }
  }
`;

export const ADD_SCREEN_NAME = gql`
  mutation AddScreenName(
    $screenName: String!
    $source: String
    $sourceId: Int
    $sourceUrl: String
    $id: Int
  ) {
    addScreenName(
      screenName: $screenName
      source: $source
      sourceId: $sourceId
      sourceUrl: $sourceUrl
      id: $id
    ) {
      ok
      screenName {
        id
        screenName
      }
    }
  }
`;
export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(email: $email) {
      statusCode
      message
    }
  }
`;

// BE-side cleanup the FE runs BEFORE handing off to Cognito on logout.
// Generic by design: the BE bumps any per-user caches (opp-type
// permissions today, more later) so the next login lands on fresh data
// rather than the previous session's cached state.
export const PRE_LOGOUT = gql`
  mutation PreLogout($userId: Int!) {
    preLogout(userId: $userId) {
      statusCode
      message
    }
  }
`;
export const CREATE_CRM_INTEGRATION = gql`
  mutation CreateCrmIntegration(
    $companyId: Int!
    $integrationType: String!
    $adfEmail: String!
    $crmDealerId: String!
    $crmFranchiseId: String!
    $elSubscriptionId: String
    $vsLeadSourceId: String!
    $sfApiUrl: String!
    $sfApiKey: String!
    $sfApiUser: String!
    $locationId: Int
    $isGlobalCrm: Boolean
  ) {
    createCrmIntegration(
      companyId: $companyId
      integrationType: $integrationType
      adfEmail: $adfEmail
      crmDealerId: $crmDealerId
      elSubscriptionId: $elSubscriptionId
      vsLeadSourceId: $vsLeadSourceId
      sfApiUrl: $sfApiUrl
      sfApiKey: $sfApiKey
      sfApiUser: $sfApiUser
      crmFranchiseId: $crmFranchiseId
      locationId: $locationId
      isGlobalCrm: $isGlobalCrm
    ) {
      statusCode
      message
      crmIntegrations {
        id
        companyId
        integrationType
        adfEmail
        crmDealerId
        vsLeadSourceId
        sfApiUrl
        sfApiKey
        sfApiUser
        sfCertificateKey
        elSubscriptionId
        crmFranchiseId
        locationId
        location {
          id
          title
          locationType
        }
      }
    }
  }
`;
export const UPDATE_CRM_INTEGRATION = gql`
  mutation updateCrmIntegration(
    $crmIntegrationId: Int!
    $integrationType: String!
    $adfEmail: String!
    $crmDealerId: String!
    $crmFranchiseId: String!
    $elSubscriptionId: String
    $vsLeadSourceId: String!
    $sfApiUrl: String!
    $sfApiKey: String!
    $sfApiUser: String!
    $locationId: Int
    $active: Boolean
  ) {
    updateCrmIntegration(
      crmIntegrationId: $crmIntegrationId
      integrationType: $integrationType
      adfEmail: $adfEmail
      crmDealerId: $crmDealerId
      elSubscriptionId: $elSubscriptionId
      vsLeadSourceId: $vsLeadSourceId
      sfApiUrl: $sfApiUrl
      sfApiKey: $sfApiKey
      sfApiUser: $sfApiUser
      crmFranchiseId: $crmFranchiseId
      locationId: $locationId
      active: $active
    ) {
      statusCode
      message
      crmIntegrations {
        id
        companyId
        integrationType
        adfEmail
        crmDealerId
        vsLeadSourceId
        sfApiUrl
        sfApiKey
        sfApiUser
        sfCertificateKey
        elSubscriptionId
        crmFranchiseId
        locationId
        location {
          id
          title
          locationType
        }
      }
    }
  }
`;

export const DELETE_CRM_INTEGRATION = gql`
  mutation DeleteCrmIntegration($crmIntegrationId: Int!) {
    deleteCrmIntegration(crmIntegrationId: $crmIntegrationId) {
      statusCode
      message
    }
  }
`;

export const UPDATE_DEAL_SUBSCRIPTIOM = gql`
  mutation UpdateDealSubscription($dealId: Int!, $subscribed: Boolean!) {
    updateDealSubscription(dealId: $dealId, subscribed: $subscribed) {
      ok
    }
  }
`;

export const SAVE_INITIAL_SENT = gql`
  mutation SaveInitialConversationSent($aingineId: Int!, $response: String!) {
    saveSentConversation(aingineId: $aingineId, response: $response) {
      ok
    }
  }
`;

export const PUSH_DEAL_TO_CRM = gql`
  mutation PushDealToCrm(
    $companyId: Int!
    $dealId: Int!
    $aingineDataId: Int
    $typeOfLead: String!
    $status: String
    $interest: String!
    $year: String!
    $make: String!
    $model: String!
    $contactFirstName: String!
    $contactLastName: String!
    $contactFullName: String
    $contactEmail: String
    $contactPhoneNumber: String!
    $contactAddressLine1: String!
    $contactAddressLine2: String
    $city: String
    $state: String!
    $zip: String
    $country: String!
    $comments: String!
    $vehicles: [VehicleInputs]
  ) {
    pushDealToCrm(
      companyId: $companyId
      dealId: $dealId
      aingineDataId: $aingineDataId
      typeOfLead: $typeOfLead
      status: $status
      interest: $interest
      year: $year
      make: $make
      model: $model
      contactFirstName: $contactFirstName
      contactLastName: $contactLastName
      contactFullName: $contactFullName
      contactEmail: $contactEmail
      contactPhoneNumber: $contactPhoneNumber
      contactAddressLine1: $contactAddressLine1
      contactAddressLine2: $contactAddressLine2
      city: $city
      state: $state
      zip: $zip
      country: $country
      comments: $comments
      vehicles: $vehicles
    ) {
      statusCode
      message
    }
  }
`;

export const SUBMIT_SUPPORT_TICKET = gql`
  mutation SubmitSupportTicket($message: String!, $subject: String!) {
    submitSupportTicket(message: $message, subject: $subject) {
      ok
    }
  }
`;

export const RESEND_INVITE = gql`
  mutation ResendInvite($userId: Int!) {
    resendInvite(userId: $userId) {
      ok
    }
  }
`;

export const UPDATE_NOTIFICATION = gql`
  mutation UpdateNotification($id: Int!, $read: Boolean) {
    updateNotification(id: $id, read: $read) {
      ok
    }
  }
`;

export const UPDATE_NOTIFICATIONS = gql`
  mutation updateNotification($notificationInputs: [NotificationInputs]!, $leadIds: [Int]) {
    updateNotification(notificationInputs: $notificationInputs, leadIds: $leadIds) {
      statusCode
      message
    }
  }
`;

export const DELETE_EXPORT_CONFIG = gql`
  mutation deleteExportConfig($id: Int!) {
    deleteExportConfig(id: $id) {
      ok
    }
  }
`;

export const CREATE_EXPORT_CONFIG = gql`
  mutation createExportConfig(
    $email: String!
    $filters: [FilterInputs]!
    $name: String!
    $minimumCount: Int
    $emailTime: Time
    $frequency: Int
    $startDate: DateTime
    $endDate: DateTime
    $timezone: String
  ) {
    createExportConfig(
      email: $email
      filters: $filters
      name: $name
      minimumCount: $minimumCount
      emailTime: $emailTime
      frequency: $frequency
      startDate: $startDate
      endDate: $endDate
      timezone: $timezone
    ) {
      exportConfig {
        id
        userId
        name
        email
        minimumCount
        count
        frequency
        lastExported
        filters {
          typeName
          value
        }
        exports {
          id
          exportConfigId
          createdAt
          name
          path
        }
      }
    }
  }
`;

export const UPDATE_EXPORT_CONFIG = gql`
  mutation updateExportConfig(
    $id: Int!
    $email: String!
    $filters: [FilterInputs]!
    $name: String!
    $minimumCount: Int
    $emailTime: Time
    $frequency: Int
    $timezone: String
  ) {
    updateExportConfig(
      id: $id
      email: $email
      filters: $filters
      name: $name
      minimumCount: $minimumCount
      frequency: $frequency
      emailTime: $emailTime
      timezone: $timezone
    ) {
      exportConfig {
        id
        frequency
        userId
        name
        email
        minimumCount
        count
        lastExported
        filters {
          typeName
          value
        }
      }
    }
  }
`;

export const DELETE_EXPORT = gql`
  mutation deleteExport($id: Int!) {
    deleteExport(id: $id) {
      ok
    }
  }
`;

export const DOWNLOAD_EXPORT_FILE = gql`
  mutation downloadExportFile($id: Int!) {
    downloadExportFile(id: $id) {
      url
    }
  }
`;

export const UPDATE_PREDICTION_REVIEW = gql`
  mutation updatePrediction($postId: String!, $review: Boolean) {
    updatePrediction(postId: $postId, review: $review) {
      ok
    }
  }
`;

// NOTE: Apollo Resolver
export const UPDATE_PREDICTION_REVIEW_RESOLVER = gql`
  mutation UpdatePredictionReview($id: String!, $review: Boolean) {
    updatePredictionReview(id: $id, review: $review) @client
  }
`;

export const UPDATE_PROFILE_DATA = gql`
  mutation UpdateProfileData($id: Int!) {
    updateProfileData(id: $id) @client
  }
`;
export const CREATE_PERSON = gql`
  mutation CreatePerson($companySourceId: Int!, $personData: PersonInput) {
    createPerson(companySourceId: $companySourceId, personData: $personData) {
      person {
        id
      }
      ok
    }
  }
`;
export const CREATE_PERSON_USER_ACCOUNT = gql`
  mutation CreatePersonUserAccount($personData: CreateUserAccountInput, $personId: Int!) {
    createPersonUserAccount(userAccountData: $personData, personId: $personId) {
      ok
    }
  }
`;

export const UPDATE_USER_ACCOUNT = gql`
  mutation updateUserAccount($personData: UpdateUserAccountInput) {
    updateUserAccount(userAccountData: $personData) {
      ok
    }
  }
`;
export const UNASSIGN_USER_ACCOUNT = gql`
  mutation unassignUserAccount($personId: Int!, $accountId: Int!) {
    unassignUserAccount(personId: $personId, accountId: $accountId) {
      ok
    }
  }
`;
export const UPDATE_USER_ROLES = gql`
  mutation addCompanyReference($companyId: Int!, $roleId: Int!, $userId: Int!) {
    addCompanyReference(companyId: $companyId, roleId: $roleId, userId: $userId) {
      ok
    }
  }
`;
export const ADD_USER_ACCOUNT = gql`
  mutation addUserAccounts($companyId: Int!, $status: String!, $userId: Int!, $roleId: Int!) {
    addUserAccounts(companyId: $companyId, status: $status, userId: $userId, roleId: $roleId) {
      userAccountId
    }
  }
`;
export const UPDATE_USER_DEFAULT_COMPANY_ID = gql`
  mutation updateUserDefaultCompany($companyId: Int!, $userId: Int!) {
    updateUserDefaultCompany(companyId: $companyId, userId: $userId) {
      ok
    }
  }
`;

export const CREATE_LEAD = gql`
  mutation CreateLead(
    $dsEntityId: String
    $dsEventId: String
    $emails: [LeadEmailsObj]
    $firstName: String!
    $isPushCrm: Boolean
    $isSyncCheck: Boolean
    $lastName: String!
    $leadSourceType: String!
    $locationId: Int
    $opportunityName: String
    $opportunitySourceId: Int
    $opportunityStatusId: Int
    $opportunityTypeId: Int
    $leadOpportunityUsers: [UserMapping]
    $phones: [LeadPhonesObj]
    $vehicleOfInterests: [VehicleOfInterestInputObject]
    $leadAddressObj: LeadAddressInputObj
    $vsContactId: String
    $vsDealerId: String
    $elCustomerId: String
    $potentialLeads: [Int]
    $isAddPhone: Boolean
    $departmentId: Int
  ) {
    createLead(
      dsEntityId: $dsEntityId
      dsEventId: $dsEventId
      emails: $emails
      firstName: $firstName
      isPushCrm: $isPushCrm
      isSyncCheck: $isSyncCheck
      lastName: $lastName
      leadSourceType: $leadSourceType
      locationId: $locationId
      opportunityName: $opportunityName
      opportunitySourceId: $opportunitySourceId
      opportunityStatusId: $opportunityStatusId
      opportunityTypeId: $opportunityTypeId
      leadOpportunityUsers: $leadOpportunityUsers
      phones: $phones
      vehicleOfInterests: $vehicleOfInterests
      leadAddressObj: $leadAddressObj
      vsContactId: $vsContactId
      vsDealerId: $vsDealerId
      elCustomerId: $elCustomerId
      potentialLeads: $potentialLeads
      isAddPhone: $isAddPhone
      departmentId: $departmentId
    ) {
      statusCode
      message
      lead {
        id
        fullName
        firstName
        lastName
        otherSource
        unreadCount
        leadCreatedDate
        leadSourceOriginalId
        leadSourceType
        textConsentStatus
        textConsent
        textConsentDate
        preferredLanguageCode
        status
        leadUsers {
          id
          userTypeId
          userType {
            name
          }
          userId
        }
        vehicleOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        crmLeadObj {
          crmStatus
          parentCrmStatus
          activeLeadOpportunity {
            id
            opportunityStatus {
              id
              name
              parentStatus {
                id
                name
              }
            }
            opportunitySource {
              id
              name
              parentSource {
                id
                name
                parentSource {
                  id
                  name
                }
              }
            }
            vehiclesOfInterest {
              id
              leadId
              year
              make
              model
              trim
              description
              budget
              customerInterest
              inputType
              isCurrent
              isPrimary
              stockNumber
              vin
            }
          }
          dsExtractedLead {
            id
            dsLeadId
            dsSource
          }
          sfExtractedLead {
            id
            sfLeadId
          }
          mfExtractedLead {
            id
            mfProspectId
            mfCustomerId
          }
          dtExtractedLead {
            id
            dtLeadId
          }
        }
        potentialLeads
        mergeHistory
        activeAppointment {
          id
          appointmentStatus
          dateCreated
          dateUpdated
          endDatetime
          isConfirmed
          startDatetime
          timezone
          summary
          description
          leadOpportunityId
          userId
          leadOpportunity {
            id
            name
          }
        }
        leadOpportunities {
          name
          id
          createdDate
          updatedDate
          # The newly created lead is unshifted straight into the Activity
          # Center list, so this selection must cover what the lead card reads.
          # Without opportunityType the card tab filter (oppMatchesTab) drops
          # every opportunity - taking the vehicle and status with it - and
          # without opportunitySource the source row falls back to Direct.
          # Both only reappeared after a refresh, when getLeads supplied them.
          # Shape mirrors GET_EXTENSION_LIST_ACTIVITY_CENTER.
          isActive
          opportunityTypeId
          opportunityType {
            id
            name
            parentTypeId
            parentType {
              id
              name
              parentTypeId
              parentType {
                id
                name
              }
            }
          }
          opportunitySource {
            id
            name
            parentSource {
              id
              name
              parentSource {
                id
                name
              }
            }
          }
          dsOpportunityEvents {
            id
            dsEntitySource
            dsMarketingChannelName
            dsEventId
          }
          sfLeadOpportunities {
            id
            sfOpportunityId
            sfOpportunityStage
          }
          dtLeadOpportunities {
            id
            dtOpportunityId
            dtOpportunityStage
          }
          vsLeadOpportunities {
            id
            vsContactId
            vsLeadId
            vsLeadStatusMapping {
              vsLeadStatusType
              vsLeadStatus
            }
          }
          elLeadOpportunities {
            id
            elOpportunityId
            elLeadId
          }
          mfLeadOpportunities {
            id
            mfProspectId
            mfCustomerId
            mfLeadId
          }
          opportunityStatus {
            id
            name
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
          leadOpportunityUsers {
            id
            userTypeId
            userId
            user {
              id
              fullName
              companyRole {
                id
                name
              }
            }
          }
          location {
            id
            title
          }
        }
        leadSource {
          name
          id
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        leadStatusType {
          id
          type
        }
        messageStatusType {
          status
        }
        # Drives the lead card left status strip (resolveLeadStripStatus).
        # Absent, every freshly created card defaulted to the UNCONTACTED
        # colour until a refresh loaded it from getLeads.
        leadMessageSummary {
          engagementStatus
          replyState
        }
        messages {
          content
          id
          direction
          dateSent
          dateReceived
          # translatedContent
          user {
            fullName
          }
        }
        phoneNumbers {
          id
          phone
          phoneType
          lookupType
          isPrimary
          firstName
          lastName
          relationshipType
        }
        emails {
          id
          email
          emailType
          isPrimary
          firstName
          lastName
          relationshipType
        }
        location {
          id
          title
          locationType
          timezone
        }
      }
    }
  }
`;

export const UPDATE_LEAD = gql`
  mutation updateLead(
    $emails: [LeadEmailsObj]
    $firstName: String
    $isPushCrm: Boolean
    $isSyncCheck: Boolean
    $lastName: String
    $leadAddressObj: LeadAddressInputObj
    $leadId: Int!
    $phones: [LeadPhonesObj]
    $isNoResponseNeeded: Boolean
  ) {
    updateLead(
      emails: $emails
      firstName: $firstName
      isPushCrm: $isPushCrm
      isSyncCheck: $isSyncCheck
      lastName: $lastName
      leadAddressObj: $leadAddressObj
      leadId: $leadId
      phones: $phones
      isNoResponseNeeded: $isNoResponseNeeded
    ) {
      statusCode
      message
      lead {
        id
        fullName
        firstName
        lastName
        otherSource
        unreadCount
        leadCreatedDate
        leadSourceOriginalId
        leadSourceType
        textConsentStatus
        textConsent
        textConsentDate
        preferredLanguageCode
        status
        leadUsers {
          id
          userTypeId
          userType {
            name
          }
          userId
        }
        vehicleOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        crmLeadObj {
          crmStatus
          parentCrmStatus
          activeLeadOpportunity {
            id
            opportunityStatus {
              id
              name
              parentStatus {
                id
                name
              }
            }
            opportunitySource {
              id
              name
              parentSource {
                id
                name
                parentSource {
                  id
                  name
                }
              }
            }
            vehiclesOfInterest {
              id
              leadId
              year
              make
              model
              trim
              description
              budget
              customerInterest
              inputType
              isCurrent
              isPrimary
              stockNumber
              vin
            }
          }
          dsExtractedLead {
            id
            dsLeadId
            dsSource
          }
          sfExtractedLead {
            id
            sfLeadId
          }
          mfExtractedLead {
            id
            mfProspectId
            mfCustomerId
          }
          dtExtractedLead {
            id
            dtLeadId
          }
        }
        potentialLeads
        mergeHistory
        activeAppointment {
          id
          appointmentStatus
          dateCreated
          dateUpdated
          endDatetime
          isConfirmed
          startDatetime
          timezone
          summary
          description
          leadOpportunityId
          userId
          leadOpportunity {
            id
            name
          }
        }
        leadOpportunities {
          name
          id
          createdDate
          updatedDate
          dsOpportunityEvents {
            id
            dsEntitySource
            dsMarketingChannelName
            dsEventId
          }
          sfLeadOpportunities {
            id
            sfOpportunityId
            sfOpportunityStage
          }
          dtLeadOpportunities {
            id
            dtOpportunityId
            dtOpportunityStage
          }
          vsLeadOpportunities {
            id
            vsContactId
            vsLeadId
            vsLeadStatusMapping {
              vsLeadStatusType
              vsLeadStatus
            }
          }
          elLeadOpportunities {
            id
            elOpportunityId
            elLeadId
          }
          mfLeadOpportunities {
            id
            mfProspectId
            mfCustomerId
            mfLeadId
          }
          opportunityStatus {
            id
            name
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
          leadOpportunityUsers {
            id
            userTypeId
            userId
            user {
              id
              fullName
              companyRole {
                id
                name
              }
            }
          }
        }
        leadSource {
          name
          id
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        leadStatusType {
          id
          type
        }
        messageStatusType {
          status
        }
        messages {
          content
          id
          direction
          dateSent
          dateReceived
          # translatedContent
          user {
            fullName
          }
        }
        phoneNumbers {
          id
          phone
          phoneType
          lookupType
          isPrimary
          firstName
          lastName
          relationshipType
        }
        emails {
          id
          email
          emailType
          isPrimary
          firstName
          lastName
          relationshipType
        }
        location {
          id
          title
          locationType
          timezone
        }
      }
    }
  }
`;

export const UPDATE_LEAD_V2 = gql`
  mutation updateLead(
    $emails: [LeadEmailsObj]
    $firstName: String
    $isPushCrm: Boolean
    $isSyncCheck: Boolean
    $lastName: String
    $leadId: Int!
    $phones: [LeadPhonesObj]
    $leadAddressObj: LeadAddressInputObj
  ) {
    updateLead(
      emails: $emails
      firstName: $firstName
      isPushCrm: $isPushCrm
      isSyncCheck: $isSyncCheck
      lastName: $lastName
      leadId: $leadId
      phones: $phones
      leadAddressObj: $leadAddressObj
    ) {
      statusCode
      message
    }
  }
`;

export const DELETE_LEAD = gql`
  mutation DeleteLead($leadId: Int!, $isSyncCheck: Boolean, $isPushCrm: Boolean) {
    deleteLead(leadId: $leadId, isSyncCheck: $isSyncCheck, isPushCrm: $isPushCrm) {
      statusCode
      message
    }
  }
`;

export const CREATE_LEAD_EMAIL = gql`
  mutation CreateLeadEmail(
    $leadId: Int!
    $email: String!
    $emailType: String
    $isSyncCheck: Boolean
    $isPushCrm: Boolean
  ) {
    createLeadEmail(
      leadId: $leadId
      emails: $emails
      isSyncCheck: $isSyncCheck
      isPushCrm: $isPushCrm
    ) {
      statusCode
      message
      leadEmail {
        id
        email
        emailType
      }
    }
  }
`;

export const UPDATE_LEAD_EMAIL = gql`
  mutation UpdateLeadEmail(
    $id: Int!
    $email: String!
    $emailType: String
    $isSyncCheck: Boolean
    $isPushCrm: Boolean
  ) {
    updateLeadEmail(
      leadEmailId: $id
      emails: $emails
      isSyncCheck: $isSyncCheck
      isPushCrm: $isPushCrm
    ) {
      statusCode
      message
      leadEmail {
        id
        email
        emailType
        isPrimary
        firstName
        lastName
        relationshipType
      }
    }
  }
`;

export const DELETE_LEAD_EMAIL = gql`
  mutation DeleteLeadEmail($id: Int!, $isSyncCheck: Boolean, $isPushCrm: Boolean) {
    deleteLeadEmail(leadEmail: $id, isSyncCheck: $isSyncCheck, isPushCrm: $isPushCrm) {
      statusCode
      message
    }
  }
`;

export const CREATE_LEAD_PHONE = gql`
  mutation CreateLeadPhone(
    $leadId: Int!
    $phone: String!
    $phoneType: String
    $isSyncCheck: Boolean
    $isPushCrm: Boolean
  ) {
    createLeadPhone(
      leadId: $leadId
      phone: $phone
      phoneType: $phoneType
      isSyncCheck: $isSyncCheck
      isPushCrm: $isPushCrm
    ) {
      statusCode
      message
      leadPhone {
        id
        phone
        phoneType
      }
    }
  }
`;

export const UPDATE_LEAD_PHONE = gql`
  mutation UpdateLeadPhone(
    $id: Int!
    $phone: String!
    $phoneType: String
    $isSyncCheck: Boolean
    $isPushCrm: Boolean
    $leadId: Int!
  ) {
    updateLeadPhone(
      leadPhoneId: $id
      phone: $phone
      phoneType: $phoneType
      isSyncCheck: $isSyncCheck
      isPushCrm: $isPushCrm
      leadId: $leadId
    ) {
      statusCode
      message
      leadPhone {
        id
        phone
        phoneType
        lookupType
        isPrimary
        firstName
        lastName
        relationshipType
      }
    }
  }
`;

export const DELETE_LEAD_PHONE = gql`
  mutation DeleteLeadPhone($id: Int!, $isSyncCheck: Boolean, $isPushCrm: Boolean) {
    deleteLeadPhone(leadPhoneId: $id, isSyncCheck: $isSyncCheck, isPushCrm: $isPushCrm) {
      statusCode
      message
    }
  }
`;

export const CREATE_LEAD_ADDRESS = gql`
  mutation CreateLeadAddress(
    $leadId: Int!
    $addressLine1: String
    $addressLine2: String
    $city: String
    $country: String
    $locationText: String
    $postalCode: String
    $state: String
    $isSyncCheck: Boolean
    $isPushCrm: Boolean
  ) {
    createLeadAddress(
      leadId: $leadId
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      city: $city
      country: $country
      locationText: $locationText
      postalCode: $postalCode
      state: $state
      isSyncCheck: $isSyncCheck
      isPushCrm: $isPushCrm
    ) {
      statusCode
      message
      leadAddress {
        id
        leadId
        locationText
        addressLine1
        addressLine2
        city
        state
        postalCode
        country
      }
    }
  }
`;
export const CREATE_CAMPAIGN = gql`
  mutation CreateCampaign(
    $activeInd: String
    $campaignLeads: [Int]
    $endDate: DateTime
    $isAcceptTerms: Boolean
    $isDisabled: Boolean
    $isPrioritize: Boolean
    $messages: [CampaignMessage]
    $method: String
    $name: String!
    $source: [Int]
    $startDate: DateTime
    $status: [Int]
    $textMessage: String
    $campaignType: String
    $extraData: GenericScalar
  ) {
    createCampaign(
      activeInd: $activeInd
      campaignLeads: $campaignLeads
      endDate: $endDate
      isAcceptTerms: $isAcceptTerms
      isDisabled: $isDisabled
      isPrioritize: $isPrioritize
      messages: $messages
      method: $method
      name: $name
      source: $source
      startDate: $startDate
      status: $status
      textMessage: $textMessage
      campaignType: $campaignType
      extraData: $extraData
    ) {
      statusCode
      message
      campaign {
        id
        name
      }
    }
  }
`;

export const CLONE_CAMPAIGN = gql`
  mutation CloneCampaign($campaignId: Int!, $name: String!) {
    cloneCampaign(campaignId: $campaignId, name: $name) {
      statusCode
      message
      campaign {
        id
        name
      }
    }
  }
`;

export const UPDATE_LEAD_ADDRESS = gql`
  mutation UpdateLeadAddress(
    $id: Int!
    $locationText: String
    $addressLine1: String
    $addressLine2: String
    $city: String
    $state: String
    $postalCode: String
    $country: String
    $isSyncCheck: Boolean
    $isPushCrm: Boolean
  ) {
    updateLeadAddress(
      id: $id
      locationText: $locationText
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      city: $city
      state: $state
      postalCode: $postalCode
      country: $country
      isSyncCheck: $isSyncCheck
      isPushCrm: $isPushCrm
    ) {
      leadAddress {
        id
        leadId
        locationText
        addressLine1
        addressLine2
        city
        state
        postalCode
        country
      }
      statusCode
      message
    }
  }
`;

export const DELETE_LEAD_ADDRESS = gql`
  mutation DeleteLeadAddress($id: Int!, $isSyncCheck: Boolean, $isPushCrm: Boolean) {
    deleteLeadAddress(id: $id, isSyncCheck: $isSyncCheck, isPushCrm: $isPushCrm) {
      statusCode
      message
    }
  }
`;

export const CREATE_LEAD_VEHICLE_OF_INTEREST = gql`
  mutation CreateLeadVehicleOfInterest(
    $leadId: Int!
    $voiObject: VehicleOfInterestInputObject!
    $leadOpportunityId: Int
    $isSyncCheck: Boolean
    $isPushCrm: Boolean
  ) {
    createLeadVehicleOfInterest(
      leadId: $leadId
      voiObject: $voiObject
      leadOpportunityId: $leadOpportunityId
      isSyncCheck: $isSyncCheck
      isPushCrm: $isPushCrm
    ) {
      statusCode
      message
      leadVehicleOfInterest {
        id
        leadId
        budget
        description
        make
        model
        trim
        year
        vin
        stockNumber
        isCurrent
        customerInterest
        inputType
        isPrimary
        bodyStyle
        condition
        mileage
        interiorColor
        exteriorColor
        extraData
      }
    }
  }
`;

export const UPDATE_LEAD_VEHICLE_OF_INTEREST = gql`
  mutation UpdateLeadVehicleOfInterest(
    $id: Int!
    $voiObject: VehicleOfInterestInputObject!
    $isSyncCheck: Boolean
    $isPushCrm: Boolean
  ) {
    updateLeadVehicleOfInterest(
      id: $id
      voiObject: $voiObject
      isSyncCheck: $isSyncCheck
      isPushCrm: $isPushCrm
    ) {
      leadVehicleOfInterest {
        id
        leadId
        budget
        description
        make
        model
        year
        trim
        stockNumber
        isCurrent
        customerInterest
        inputType
        isPrimary
        vin
        bodyStyle
        condition
        mileage
        interiorColor
        exteriorColor
        extraData
      }
      statusCode
      message
    }
  }
`;

export const DELETE_LEAD_VEHICLE_OF_INTEREST = gql`
  mutation DeleteLeadVehicleOfInterest($id: Int!, $isSyncCheck: Boolean, $isPushCrm: Boolean) {
    deleteLeadVehicleOfInterest(id: $id, isSyncCheck: $isSyncCheck, isPushCrm: $isPushCrm) {
      statusCode
      message
    }
  }
`;

export const UPDATE_CAMPAIGN = gql`
  mutation UpdateCampaign(
    $activeInd: String
    $campaignLeads: [Int]
    $endDate: DateTime
    $id: Int!
    $isAcceptTerms: Boolean
    $isDisabled: Boolean
    $isPrioritize: Boolean
    $messages: [CampaignMessage]
    $method: String
    $name: String!
    $source: [Int]
    $startDate: DateTime
    $status: [Int]
    $textMessage: String
    $campaignType: String
    $extraData: GenericScalar
  ) {
    updateCampaign(
      activeInd: $activeInd
      campaignLeads: $campaignLeads
      endDate: $endDate
      id: $id
      isAcceptTerms: $isAcceptTerms
      isDisabled: $isDisabled
      isPrioritize: $isPrioritize
      messages: $messages
      method: $method
      name: $name
      source: $source
      startDate: $startDate
      status: $status
      textMessage: $textMessage
      campaignType: $campaignType
      extraData: $extraData
    ) {
      statusCode
      message
      campaign {
        id
        name
        campaignSelections {
          id
          type
          value
        }
      }
    }
  }
`;
export const DELETE_CAMPAIGN = gql`
  mutation DeleteCampaign($id: Int!) {
    deleteCampaign(id: $id) {
      statusCode
      message
    }
  }
`;

export const UPDATE_CAMPAIGN_SCHEDULE = gql`
  mutation UpdateCampaignSchedules(
    $id: Int!
    $type: String!
    $numericValue: Int!
    $temporalValue: String!
    $title: String!
    $sortOrder: Int!
  ) {
    updateCampaignSchedules(
      id: $id
      type: $type
      numericValue: $numericValue
      temporalValue: $temporalValue
      title: $title
      sortOrder: $sortOrder
    ) {
      campaignSchedule {
        id
        type
        numericValue
        temporalValue
        title
        sortOrder
      }
    }
  }
`;
export const CREATE_CAMPAIGN_SCHEDULES = gql`
  mutation createCampaignSchedules($campaignId: Int!, $message: CampaignMessage!) {
    createCampaignSchedules(campaignId: $campaignId, message: $message) {
      statusCode
      campaignSchedule {
        id
      }
    }
  }
`;
export const UPDATE_CAMPAIGN_SCHEDULES = gql`
  mutation updateCampaignSchedules($message: CampaignMessage) {
    updateCampaignSchedules(message: $message) {
      statusCode
      campaignSchedule {
        id
      }
    }
  }
`;
export const CREATE_CAMPAIGN_SCHEDULE = gql`
  mutation CreateCampaignSchedule(
    $campaignId: Int!
    $type: String!
    $numericValue: Int!
    $temporalValue: String!
    $title: String!
    $sortOrder: Int!
  ) {
    createCampaignSchedule(
      campaignId: $campaignId
      type: $type
      numericValue: $numericValue
      temporalValue: $temporalValue
      title: $title
      sortOrder: $sortOrder
    ) {
      statusCode
      campaignSchedule {
        id
        type
        numericValue
        temporalValue
        title
        sortOrder
      }
    }
  }
`;

export const CREATE_CAMPAIGN_TEMPLATE = gql`
  mutation CreateCampaignTemplates(
    $campaignId: Int!
    $scheduleId: Int!
    $sources: [Int]!
    $templateText: [String]!
    $afterHourTemplateText: [String]!
    $isAfterHour: Boolean!
  ) {
    createCampaignTemplates(
      campaignId: $campaignId
      scheduleId: $scheduleId
      sources: $sources
      templateText: $templateText
      afterHourTemplateText: $afterHourTemplateText
      isAfterHour: $isAfterHour
    ) {
      campaignTemplates {
        id
      }
    }
  }
`;
export const UPDATE_CAMPAIGN_SCHEDULE_TEMPLATE = gql`
  mutation UpdateCampaignScheduleTemplates(
    $campaignId: Int!
    $scheduleId: Int!
    $sources: [Int]!
    $templateText: [String]!
    $afterHourTemplateText: [String]!
    $isAfterHour: Boolean!
  ) {
    updateCampaignScheduleTemplates(
      campaignId: $campaignId
      scheduleId: $scheduleId
      sources: $sources
      templateText: $templateText
      afterHourTemplateText: $afterHourTemplateText
      isAfterHour: $isAfterHour
    ) {
      ok
      campaignTemplates {
        id
      }
    }
  }
`;
export const UPDATE_CAMPAIGN_SCHEDULE_SORT_ORDERS = gql`
  mutation UpdateCampaignSchedulesSortorder($schedules: [Int]!, $sortOrder: [Int]!) {
    updateCampaignSchedulesSortorder(schedules: $schedules, sortOrder: $sortOrder) {
      ok
      campaignSchedules {
        id
        type
        numericValue
        temporalValue
        title
        sortOrder
      }
    }
  }
`;

export const UPDATE_CAMPAIGN_TEMPLATE = gql`
  mutation UpdateCampaignTemplate(
    $id: Int!
    $scheduleId: Int
    $sourceId: Int
    $templateText: String
    $isActive: Boolean
  ) {
    updateCampaignTemplate(
      id: $id
      scheduleId: $scheduleId
      sourceId: $sourceId
      templateText: $templateText
      isActive: $isActive
    ) {
      campaignTemplate {
        id
      }
    }
  }
`;
export const DELETE_CAMPAIGN_TEMPLATE = gql`
  mutation DeleteCampaignTemplate($id: Int!) {
    deleteCampaignTemplate(id: $id) {
      ok
    }
  }
`;
export const DELETE_CAMPAIGN_SCHEDULE = gql`
  mutation DeleteCampaignSchedule($id: Int!) {
    deleteCampaignSchedule(id: $id) {
      ok
    }
  }
`;

export const DELETE_CAMPAIGN_SCHEDULE_OPTION = gql`
  mutation DeleteCampaignScheduleOption($id: Int!) {
    deleteCampaignScheduleOption(id: $id) {
      ok
    }
  }
`;

// export const CREATE_CAMPAIGN_SCHEDULE_OPTION = gql`
//   mutation CreateCampaignScheduleOption(
//     $type: String!
//     $numericValue: Int!
//     $temporalValue: String!
//   ) {
//     createCampaignScheduleOption(
//       type: $type
//       numericValue: $numericValue
//       temporalValue: $temporalValue
//     ) {
//       campaignScheduleOption {
//         id
//       }
//     }
//   }
// `
export const CREATE_CAMPAIGN_SELECTIONS = gql`
  mutation CreateCampaignSelections(
    $campaignId: Int!
    $type: String!
    $values: [SelectionInputs]!
    $secondaryType: String
    $secondaryValues: [SelectionInputs]
  ) {
    createCampaignSelections(
      campaignId: $campaignId
      type: $type
      values: $values
      secondaryType: $secondaryType
      secondaryValues: $secondaryValues
    ) {
      campaignSelections {
        id
      }
    }
  }
`;
// export const CREATE_CAMPAIGN_SCHEDUEL = gql`
//   mutation CreateCampaignSchedule($campaignId: Int!, $schedulesOptionId: Int!) {
//     createCampaignSchedule(
//       campaignId: $campaignId
//       schedulesOptionId: $schedulesOptionId
//     ) {
//       campaignSchedule {
//         id
//         schedulesOptionId
//         campaignSchedulesOption {
//           id
//           type
//           numericValue
//           temporalValue
//         }
//       }
//     }
//   }
// `
export const CREATE_CAMPAIGN_LEAD_SUMMARY = gql`
  mutation CreateCampaignLeadSummary($campaignId: Int!) {
    createCampaignLeadSummary(campaignId: $campaignId) {
      ok
    }
  }
`;

// Reply-As default preference (EAI-1530). Saves one rule for an opportunity
// type; returns the full merged preferences JSON ({ default_rules, lead_overrides }).
export const SAVE_REPLY_AS_PREFERENCE = gql`
  mutation saveReplyAsPreference(
    $locationId: Int
    $opportunityTypeId: Int
    $ruleType: String
    $opportunityUserTypeId: Int
  ) {
    saveReplyAsPreference(
      locationId: $locationId
      opportunityTypeId: $opportunityTypeId
      ruleType: $ruleType
      opportunityUserTypeId: $opportunityUserTypeId
    ) {
      statusCode
      message
      preferences
    }
  }
`;

export const CREATE_MESSAGE = gql`
  mutation CreateMessage(
    $leadId: Int!
    $userId: Int!
    $replyAsUserId: Int
    $channelId: Int
    $campaignId: Int
    $campaignTemplateId: Int
    $direction: String
    $content: String!
    $toPhone: String
    $reviewLink: String
    $leadOpportunityId: Int
    $dsEventId: String
    $messageType: String
    $selectedOppTypeId: Int
    $aiResponseHistoryId: Int
  ) {
    createMessage(
      leadId: $leadId
      userId: $userId
      replyAsUserId: $replyAsUserId
      channelId: $channelId
      campaignId: $campaignId
      campaignTemplateId: $campaignTemplateId
      direction: $direction
      content: $content
      toPhone: $toPhone
      reviewLink: $reviewLink
      leadOpportunityId: $leadOpportunityId
      dsEventId: $dsEventId
      messageType: $messageType
      selectedOppTypeId: $selectedOppTypeId
      aiResponseHistoryId: $aiResponseHistoryId
    ) {
      statusCode
      message
      leadMessage {
        id
        systemUserId
        leadId
        userId
        originalUserId
        user {
          firstName
          lastName
          profilePic
          companyRole {
            name
          }
          phone
          email
        }
        channelId
        campaignId
        campaignTemplateId
        direction
        dateSent
        dateReceived
        content
        translatedContent
        messageType
        errorCode
        errorMessage
        contentType
        statusCode
        messageStatus
        leadOpportunityId
        messageLog {
          id
          fromPhone
          toPhone
        }
        trackingDetails {
          id
          actionType
          actionValue
        }
        leadOpportunity {
          id
          name
          opportunityType {
            id
            name
            parentType {
              id
              name
            }
          }
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const CREATE_MESSAGE_LOG = gql`
  mutation CreateMessageLog($messageId: Int!, $toPhone: String!) {
    createMessageLog(messageId: $messageId, toPhone: $toPhone) {
      messageLog {
        id
        fromPhone
        toPhone
      }
    }
  }
`;

export const CREATE_CHANNEL = gql`
  mutation CreateChannel($name: String!, $channelType: String!) {
    createChannel(name: $name, channelType: $channelType) {
      channel {
        id
        name
        channelType
      }
    }
  }
`;

export const UPDATE_CHANNEL = gql`
  mutation UpdateChannel($id: Int!, $name: String!, $channelType: String!) {
    updateChannel(id: $id, name: $name, channelType: $channelType) {
      channel {
        id
        name
        channelType
      }
      ok
    }
  }
`;

export const DELETE_CHANNEL = gql`
  mutation DeleteChannel($id: Int!) {
    deleteChannel(id: $id) {
      ok
    }
  }
`;

export const UPDATE_CRM_INTEGRATION_USER = gql`
  mutation UpdateCrmIntegrationUser($userId: Int!, $crmIntegrationId: Int!, $crmUserId: String!) {
    updateCrmIntegrationUser(
      userId: $userId
      crmIntegrationId: $crmIntegrationId
      crmUserId: $crmUserId
    ) {
      ok
    }
  }
`;

const SAVE_TEMPLATE_V2 = gql`
  mutation SaveEngagementMessageTemplate(
    $userId: Int!
    $companyId: Int
    $title: String!
    $message: String!
    $id: Int
    $isActive: Boolean
    $isCompanyShared: Boolean
    $locationIds: [Int]
    $scopes: [TemplateScopeInput]
    $opportunityTypeId: Int
    $level: TemplateLevelEnum
    $subject: String
    $templateType: TemplateTypeEnum
  ) {
    saveEngagementMessageTemplate(
      userId: $userId
      companyId: $companyId
      title: $title
      message: $message
      id: $id
      locationIds: $locationIds
      scopes: $scopes
      opportunityTypeId: $opportunityTypeId
      level: $level
      isActive: $isActive
      isCompanyShared: $isCompanyShared
      subject: $subject
      templateType: $templateType
    ) {
      message
      statusCode
      engagementMessageTemplate {
        id
        title
        message
        subject
        templateType
        level
        locationIds
        isActive
        isCompanyShared
        companyId
        locationId
        departmentId
        opportunityTypeId
        userId
        extraData
      }
    }
  }
`;

// Pre-deploy schema: no level, no locationIds, no scopes — scope is a single
// locationId plus the isCompanyShared flag.
const SAVE_TEMPLATE_V1 = gql`
  mutation SaveEngagementMessageTemplate(
    $userId: Int!
    $companyId: Int
    $title: String!
    $message: String!
    $id: Int
    $isActive: Boolean
    $isCompanyShared: Boolean
    $locationId: Int
    $subject: String
    $templateType: TemplateTypeEnum
  ) {
    saveEngagementMessageTemplate(
      userId: $userId
      companyId: $companyId
      title: $title
      message: $message
      id: $id
      locationId: $locationId
      isActive: $isActive
      isCompanyShared: $isCompanyShared
      subject: $subject
      templateType: $templateType
    ) {
      message
      statusCode
      engagementMessageTemplate {
        id
      }
    }
  }
`;

export const SAVE_ENAGEMENT_MESSAGE_TEMPLATE = isTemplatesV2()
  ? SAVE_TEMPLATE_V2
  : SAVE_TEMPLATE_V1;

export const DELETE_ENAGEMENT_MESSAGE_TEMPLATE = gql`
  mutation DeleteEngagementMessageTemplate($engagementTemplateIds: [Int]!, $userId: Int!) {
    deleteEngagementMessageTemplate(
      engagementTemplateIds: $engagementTemplateIds
      userId: $userId
    ) {
      message
      statusCode
    }
  }
`;

export const CREATE_APPOINTMENT = gql`
  mutation CreateAppointment(
    $leadId: Int!
    $userId: Int!
    $startDate: DateTime!
    $endDate: DateTime!
    $summary: String!
    $description: String
    $appointmentTimezone: String!
    $discussedVoiId: Int
    $leadOpportunityId: Int!
    $isConfirmed: Boolean
    $dsEventId: String
    $isTentativeAppointmentTime: Boolean
  ) {
    createAppointment(
      leadId: $leadId
      userId: $userId
      startDate: $startDate
      endDate: $endDate
      summary: $summary
      description: $description
      appointmentTimezone: $appointmentTimezone
      discussedVoiId: $discussedVoiId
      leadOpportunityId: $leadOpportunityId
      isConfirmed: $isConfirmed
      dsEventId: $dsEventId
      isTentativeAppointmentTime: $isTentativeAppointmentTime
    ) {
      appointment {
        id
        dateUpdated
        dateCreated
        startDatetime
        endDatetime
        timezone
        appointmentStatus
        isConfirmed
        isLastActionByLead
        extraData
        userId
        summary
        description
        discussedVoiId
        leadOpportunityId
      }
      statusCode
      message
    }
  }
`;
export const UPDATE_APPOINTMENT = gql`
  mutation UpdateAppointment(
    $appointmentId: Int!
    $userId: Int!
    $startDate: DateTime!
    $endDate: DateTime!
    $summary: String!
    $description: String
    $appointmentTimezone: String!
    $status: String
    $discussedVoiId: Int
    $leadOpportunityId: Int!
    $isConfirmed: Boolean
    $dsEventId: String
    $isTentativeAppointmentTime: Boolean
  ) {
    updateAppointment(
      appointmentId: $appointmentId
      userId: $userId
      startDate: $startDate
      endDate: $endDate
      summary: $summary
      description: $description
      appointmentTimezone: $appointmentTimezone
      appointmentStatus: $status
      discussedVoiId: $discussedVoiId
      leadOpportunityId: $leadOpportunityId
      isConfirmed: $isConfirmed
      dsEventId: $dsEventId
      isTentativeAppointmentTime: $isTentativeAppointmentTime
    ) {
      appointment {
        id
        startDatetime
        endDatetime
        dateUpdated
        dateCreated
        isLastActionByLead
        timezone
        description
        leadOpportunityId
        summary
        isConfirmed
        discussedVoiId
        extraData
        # content
        userId
        appointmentStatus
        lead {
          id
          fullName
          phoneNumbers {
            phone
          }
          emails {
            id
            email
          }
          leadSource {
            id
            name
          }
          vehicleOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
          leadVehicleInventory {
            id
            make
            model
            year
          }
          leadOpportunities {
            id
            name
            sfLeadOpportunities {
              id
              sfOpportunityId
              sfOpportunityStage
            }
            vsLeadOpportunities {
              id
              vsContactId
              vsLeadId
              vsLeadStatusMapping {
                vsLeadStatusType
                vsLeadStatus
              }
            }
            elLeadOpportunities {
              id
              elOpportunityId
              elLeadId
            }
            mfLeadOpportunities {
              id
              mfProspectId
              mfCustomerId
              mfLeadId
            }
            dsOpportunityEvents {
              id
              dsEventId
              dsEntitySource
              dsMarketingChannelName
              dsTrackingCode
            }
            dtLeadOpportunities {
              dtOpportunityId
              dtOpportunityStage
              dtLeadSource {
                leadSource {
                  name
                }
              }
            }
            opportunityStatus {
              id
              name
              parentStatus {
                name
                id
              }
            }
          }
        }
        leadOpportunityId
        leadOpportunity {
          id
          name
          leadId
          dsOpportunityEvents {
            id
            dsEventId
            dsEntitySource
            dsMarketingChannelName
            dsTrackingCode
          }
          sfLeadOpportunities {
            id
            sfOpportunityId
            sfOpportunityStage
          }
          vsLeadOpportunities {
            id
            vsContactId
            vsLeadId
            vsLeadStatusMapping {
              vsLeadStatusType
              vsLeadStatus
            }
          }
          elLeadOpportunities {
            id
            elOpportunityId
            elLeadId
          }
          mfLeadOpportunities {
            id
            mfProspectId
            mfCustomerId
            mfLeadId
          }
          opportunityType {
            id
            name
            parentType {
              id
              name
            }
          }
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
        }
        createdBy {
          id
          fullName
          dateCreated
        }
        updatedBy {
          id
          fullName
          dateCreated
        }
        user {
          id
          fullName
          companyRole {
            id
            name
          }
        }
        locationId
      }
      statusCode
      message
    }
  }
`;
export const RESCHEDULE_APPOINTMENT = gql`
  mutation rescheduleAppointment(
    $appointmentId: Int
    $startDate: DateTime!
    $endDate: DateTime!
    $appointmentTimezone: String!
    $leadId: Int!
    $userId: Int!
    $discussedVoiId: Int
    $isConfirmed: Boolean
    $isTentativeAppointmentTime: Boolean
    $leadOpportunityId: Int
  ) {
    rescheduleAppointment(
      appointmentId: $appointmentId
      startDate: $startDate
      endDate: $endDate
      appointmentTimezone: $appointmentTimezone
      leadId: $leadId
      userId: $userId
      discussedVoiId: $discussedVoiId
      isConfirmed: $isConfirmed
      isTentativeAppointmentTime: $isTentativeAppointmentTime
      leadOpportunityId: $leadOpportunityId
    ) {
      appointment {
        id
        startDatetime
        endDatetime
        status
        appointmentStatus
        extraData
      }
      statusCode
      message
    }
  }
`;

export const UPDATE_LEAD_CONSENT = gql`
  mutation UpdateLeadConsentStatus($leadId: Int!) {
    updateLeadConsentStatus(id: $leadId) {
      ok
      lead {
        id
        textConsentDate
        textConsentStatus
      }
    }
  }
`;

export const DELETE_APPOINTMENT = gql`
  mutation DeleteAppointment($appointmentId: Int!) {
    deleteAppointment(appointmentId: $appointmentId) {
      statusCode
      message
    }
  }
`;

export const CREATE_LEAD_VEHICLES = gql`
  mutation createLeadVehicleOfInterests(
    $leadId: Int!
    $voiObject: [VehicleOfInterestInputObject]!
    $isSyncCheck: Boolean
    $isPushCrm: Boolean
  ) {
    createLeadVehicleOfInterests(
      leadId: $leadId
      voiObjects: $voiObject
      isSyncCheck: $isSyncCheck
      isPushCrm: $isPushCrm
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_COMPANY_WORK_HOURS = gql`
  mutation updateWorkingHours(
    $companyId: Int!
    $inputWorkingHours: [WorkingHourInputs]!
    $locationId: Int
  ) {
    updateWorkingHours(
      companyId: $companyId
      inputWorkingHours: $inputWorkingHours
      locationId: $locationId
    ) {
      statusCode
      message
      workingHours {
        id
        companyId
        weekDay
        isWorkingDay
        startTime
        endTime
      }
    }
  }
`;
export const CREATE_CAMPANY_PHONE_BOT = gql`
  mutation CreatePhoneService(
    $companyId: Int!
    $locationId: Int!
    $phone: String!
    $type: String!
    $serviceName: String!
    $phoneServiceProvider: String!
    $description: String
    $accountSid: String
    $authToken: String
    $messagingProfileId: String
    $voiceApiKey: String
    $voiceApiSecret: String
    $voiceTwimlSid: String
    $extraData: GenericScalar
  ) {
    createPhoneService(
      companyId: $companyId
      locationId: $locationId
      phone: $phone
      type: $type
      serviceName: $serviceName
      phoneServiceProvider: $phoneServiceProvider
      description: $description
      accountSid: $accountSid
      authToken: $authToken
      messagingProfileId: $messagingProfileId
      voiceApiKey: $voiceApiKey
      voiceApiSecret: $voiceApiSecret
      voiceTwimlSid: $voiceTwimlSid
      extraData: $extraData
    ) {
      phoneService {
        id
        companyId
        locationId
        userId
        serviceName
        phoneServiceProvider
        description
        accountSid
        authToken
        messagingProfileId
        voiceApiKey
        voiceApiSecret
        voiceTwimlSid
        extraData
        isDeleted
        createdOn
        updatedOn
        user {
          id
          email
          firstName
          lastName
          phone
        }
      }
      statusCode
      message
    }
  }
`;
export const UPDATE_CAMPANY_PHONE_BOT = gql`
  mutation updatePhoneService(
    $phoneServiceId: Int!
    $phone: String!
    $type: String!
    $serviceName: String!
    $description: String
    $accountSid: String
    $authToken: String
    $messagingProfileId: String
    $voiceApiKey: String
    $voiceApiSecret: String
    $voiceTwimlSid: String
    $extraData: GenericScalar
  ) {
    updatePhoneService(
      phoneServiceId: $phoneServiceId
      phone: $phone
      type: $type
      serviceName: $serviceName
      description: $description
      accountSid: $accountSid
      authToken: $authToken
      messagingProfileId: $messagingProfileId
      voiceApiKey: $voiceApiKey
      voiceApiSecret: $voiceApiSecret
      voiceTwimlSid: $voiceTwimlSid
      extraData: $extraData
    ) {
      phoneService {
        id
        companyId
        locationId
        userId
        serviceName
        phoneServiceProvider
        description
        accountSid
        authToken
        messagingProfileId
        voiceApiKey
        voiceApiSecret
        voiceTwimlSid
        extraData
        isDeleted
        createdOn
        updatedOn
        user {
          id
          email
          firstName
          lastName
          phone
        }
      }
      statusCode
      message
    }
  }
`;

export const DELETE_PHONE_BOT = gql`
  mutation deletePhoneService($phoneServiceId: Int!) {
    deletePhoneService(phoneServiceId: $phoneServiceId) {
      statusCode
      message
    }
  }
`;
export const SAVE_LEAD_NOTE = gql`
  mutation SaveLeadNote($leadId: Int!, $note: String!) {
    saveLeadNote(leadId: $leadId, note: $note) {
      statusCode
      message
    }
  }
`;

export const UPDATE_LEAD_CONVERSATION_STATUS = gql`
  mutation enableDisableLeadConversation($leadId: Int!, $disableConversation: Boolean!) {
    enableDisableLeadConversation(leadId: $leadId, disableConversation: $disableConversation) {
      statusCode
      message
      lead {
        id
        conversationStatus {
          id
          userId
          disableConversation
          createdOn
        }
      }
    }
  }
`;

export const CREATE_FCM_DEVICE = gql`
  mutation createFcmDevice($registrationId: String!) {
    createFcmDevice(registrationId: $registrationId) {
      statusCode
      message
    }
  }
`;

export const DELETE_FCM_DEVICE = gql`
  mutation deleteFcmDevice($registrationId: String!) {
    deleteFcmDevice(registrationId: $registrationId) {
      statusCode
      message
    }
  }
`;
export const UPDATE_COMPANY_NUDGE_SETTINGS = gql`
  mutation updateCompanyNudgeEvent(
    $companyId: Int!
    $companyNudgeEventInputs: [CompanyNudgeEventInputs]!
  ) {
    updateCompanyNudgeEvent(
      companyId: $companyId
      companyNudgeEventInputs: $companyNudgeEventInputs
    ) {
      statusCode
      message
      companyNudgeEvents {
        nudgeEvent {
          id
          code
          title
        }
        companyNudgeEvent {
          id
          nudgeEventId
          startDelay
          startDelayType
          frequency
          frequencyType
          firstTemplateText
          reminderTemplateText
          parentTemplateText
          isSms
          isEmail
          isWebPush
          isActive
          reminderCount
          tentativeTemplateText
          tentativeReminderTemplateText
        }
      }
    }
  }
`;
// EAI-1598 — self-service per-user nudge preferences. Scope (assignedUserId /
// companyId) is forced server-side to the caller, so the input carries no
// company/location/user fields.
export const UPDATE_MY_NUDGE_PREFERENCES = gql`
  mutation updateMyNudgePreferences($myNudgePreferenceInputs: [MyNudgePreferenceInputs]!) {
    updateMyNudgePreferences(myNudgePreferenceInputs: $myNudgePreferenceInputs) {
      statusCode
      message
      companyNudgeEvents {
        nudgeEvent {
          id
          code
          title
        }
        companyNudgeEvent {
          id
          nudgeEventId
          startDelay
          startDelayType
          frequency
          frequencyType
          firstTemplateText
          reminderTemplateText
          parentTemplateText
          isSms
          isEmail
          isWebPush
          isActive
          reminderCount
          assignedUserId
          extraData
          tentativeTemplateText
          tentativeReminderTemplateText
        }
      }
    }
  }
`;

export const CREATE_REGION = gql`
  mutation createCompanyRegion($companyId: Int!, $name: String!, $isDefault: Boolean!) {
    createCompanyRegion(companyId: $companyId, name: $name, isDefault: $isDefault) {
      statusCode
      message
      region {
        id
        name
      }
    }
  }
`;
export const UPDATE_REGION = gql`
  mutation UpdateCompanyRegion(
    $regionId: Int!
    $name: String!
    $isDefault: Boolean!
    $isActive: Boolean
  ) {
    updateCompanyRegion(
      regionId: $regionId
      name: $name
      isDefault: $isDefault
      isActive: $isActive
    ) {
      statusCode
      message
      region {
        id
        name
      }
    }
  }
`;

export const DELETE_COMPANY_REGION = gql`
  mutation deleteCompanyRegion($regionId: Int!) {
    deleteCompanyRegion(regionId: $regionId) {
      statusCode
      message
    }
  }
`;

export const CREATE_LOCATION = gql`
  mutation createCompanyLocation(
    $companyId: Int!
    $addressLine1: String
    $addressLine2: String
    $city: String
    $country: String
    $email: String
    $geoLink: String
    $inventoryUrlFormat: String
    $isActive: Boolean
    $isDefault: Boolean!
    $locationType: String
    $notes: String
    $phone: String
    $postalCode: String
    $regionId: Int!
    $settings: GenericScalar
    $state: String
    $timezone: String
    $title: String!
    $website: String
    $opportunityTypeId: Int
  ) {
    createCompanyLocation(
      companyId: $companyId
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      city: $city
      country: $country
      email: $email
      geoLink: $geoLink
      inventoryUrlFormat: $inventoryUrlFormat
      isActive: $isActive
      isDefault: $isDefault
      locationType: $locationType
      notes: $notes
      phone: $phone
      postalCode: $postalCode
      regionId: $regionId
      settings: $settings
      state: $state
      timezone: $timezone
      title: $title
      website: $website
      opportunityTypeId: $opportunityTypeId
    ) {
      statusCode
      message
      location {
        id
        companyId
        regionId
        locationType
        title
        phone
        email
        addressLine1
        city
        state
        postalCode
        country
        geoLink
        website
        timezone
        isActive
        isDefault
        inventoryUrlFormat
        region {
          id
          name
        }
        openaiApiKey
        notes
        settings
      }
    }
  }
`;

export const UPDATE_LOCATION = gql`
  mutation updateCompanyLocation(
    $addressLine1: String
    $addressLine2: String
    $city: String
    $country: String
    $email: String
    $geoLink: String
    $inventoryUrlFormat: String
    $isActive: Boolean
    $isDefault: Boolean!
    $locationId: Int!
    $locationType: String
    $notes: String
    $phone: String
    $postalCode: String
    $regionId: Int!
    $settings: GenericScalar
    $state: String
    $timezone: String
    $title: String!
    $website: String
    $opportunityTypeId: Int
  ) {
    updateCompanyLocation(
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      city: $city
      country: $country
      email: $email
      geoLink: $geoLink
      inventoryUrlFormat: $inventoryUrlFormat
      isActive: $isActive
      isDefault: $isDefault
      locationId: $locationId
      locationType: $locationType
      notes: $notes
      phone: $phone
      postalCode: $postalCode
      regionId: $regionId
      settings: $settings
      state: $state
      timezone: $timezone
      title: $title
      website: $website
      opportunityTypeId: $opportunityTypeId
    ) {
      statusCode
      message
      location {
        id
        companyId
        regionId
        locationType
        title
        phone
        email
        addressLine1
        city
        state
        postalCode
        country
        geoLink
        website
        timezone
        isActive
        settings
        isDefault
        inventoryUrlFormat
        region {
          id
          name
        }
        workingHours {
          id
        }
        opportunityStatuses {
          id
        }
        opportunityType {
          id
          name
        }
        openaiApiKey
        notes
      }
    }
  }
`;

export const SYNC_UP_LEAD = gql`
  mutation syncUpLead($leadId: Int!) {
    syncUpLead(leadId: $leadId) {
      statusCode
      message
    }
  }
`;

export const CREATE_REVIEW = gql`
  mutation CreateReview(
    $email: String
    $head: String
    $body: String
    $reviewType: String
    $reviewUrl: String!
  ) {
    createReview(
      email: $email
      head: $head
      body: $body
      reviewType: $reviewType
      reviewUrl: $reviewUrl
    ) {
      statusCode
      message
    }
  }
`;

export const CREATE_REVIEW_TEMPLATE = gql`
  mutation CreateReviewTemplate($image: String!) {
    createReviewTemplate(image: $image) {
      statusCode
      message
    }
  }
`;

export const CREATE_MMS_MESSAGE = gql`
  mutation CreateMmsMessage(
    $leadId: Int!
    $userId: Int!
    $channelId: Int
    $campaignId: Int
    $campaignTemplateId: Int
    $direction: String
    $content: String!
    $toPhone: String!
    $imageUrl: String!
  ) {
    createMmsMessage(
      leadId: $leadId
      userId: $userId
      channelId: $channelId
      campaignId: $campaignId
      campaignTemplateId: $campaignTemplateId
      direction: $direction
      content: $content
      toPhone: $toPhone
      imageUrl: $imageUrl
    ) {
      statusCode
      message
      leadMessage {
        id
        systemUserId
        leadId
        userId
        channelId
        campaignId
        campaignTemplateId
        direction
        dateSent
        dateReceived
        content
        errorCode
        errorMessage
        statusCode
        messageStatus
        messageType
        messageLog {
          id
          fromPhone
          toPhone
        }
      }
    }
  }
`;

export const CREATE_REVIEW_INFO = gql`
  mutation CreateReviewInfo(
    $companyId: Int!
    $locationId: Int!
    $reviewSource: String!
    $accountId: String
    $accessToken: String
    $reviewPostLink: String
    $sourceLink: String
    $accountLocationId: String
  ) {
    createReviewInfo(
      companyId: $companyId
      locationId: $locationId
      reviewSource: $reviewSource
      accountId: $accountId
      accessToken: $accessToken
      reviewPostLink: $reviewPostLink
      sourceLink: $sourceLink
      accountLocationId: $accountLocationId
    ) {
      statusCode
      message
      reviewInfo {
        id
        companyId
        locationId
        reviewSource
        sourceLink
        reviewPostLink
        accessToken
        accountId
        accountLocationId
        isActive
      }
    }
  }
`;

export const UPDATE_REVIEW_INFO = gql`
  mutation UpdateReviewInfo(
    $reviewInfoId: Int!
    $companyId: Int!
    $locationId: Int!
    $reviewSource: String!
    $accountId: String
    $accessToken: String
    $reviewPostLink: String
    $sourceLink: String
    $accountLocationId: String
    $isActive: Boolean
  ) {
    updateReviewInfo(
      reviewInfoId: $reviewInfoId
      companyId: $companyId
      locationId: $locationId
      reviewSource: $reviewSource
      accountId: $accountId
      accessToken: $accessToken
      reviewPostLink: $reviewPostLink
      sourceLink: $sourceLink
      accountLocationId: $accountLocationId
      isActive: $isActive
    ) {
      statusCode
      message
      reviewInfo {
        id
        companyId
        locationId
        reviewSource
        sourceLink
        reviewPostLink
        accessToken
        accountId
        accountLocationId
        isActive
      }
    }
  }
`;
export const REMOVE_LEAD_FROM_CAMPAIGN = gql`
  mutation removeLeadsFromCampaign(
    $campaignId: Int!
    $leadIds: [Int]!
    $isExcludeLastWeek: Boolean
  ) {
    removeLeadsFromCampaign(
      campaignId: $campaignId
      leadIds: $leadIds
      isExcludeLastWeek: $isExcludeLastWeek
    ) {
      statusCode
      message
      campaignLeads {
        id
        firstName
        lastName
        campaignObj {
          campaigns {
            id
            name
            activeInd
          }
          activelyCampaign
        }
      }
    }
  }
`;
export const UPDATE_COMPANY_APPOINTMENT_SETTING = gql`
  mutation updateCompanyAppointmentSettingEvent(
    $companyId: Int!
    $companyAppointmentSettingEventInputs: [CompanyAppointmentSettingEventInputs]!
  ) {
    updateCompanyAppointmentSettingEvent(
      companyId: $companyId
      companyAppointmentSettingEventInputs: $companyAppointmentSettingEventInputs
    ) {
      statusCode
      message
      companyAppointmentSettingEvents {
        appointmentSettingEvent {
          id
          code
          title
          isActive
        }
        companyAppointmentSettingEvent {
          id
          appointmentSettingEventId
          companyId
          templateText
          isSms
          isEmail
          isActive
          tentativeTemplateText
        }
      }
    }
  }
`;
export const CREATE_COMPANY_ROLE = gql`
  mutation CreateCompanyRole(
    $companyId: Int!
    $name: String!
    $parentRoleId: Int
    $companyRoleId: Int
    $locationId: Int!
    $isOpenCrmWarningPopup: Boolean
  ) {
    createCompanyRole(
      companyId: $companyId
      name: $name
      parentRoleId: $parentRoleId
      companyRoleId: $companyRoleId
      locationId: $locationId
      isOpenCrmWarningPopup: $isOpenCrmWarningPopup
    ) {
      statusCode
      message
      companyRole {
        id
        name
        isOpenCrmWarningPopup
        companyId
        parentRoleId
        isSmaiRole
        isActive
        locations {
          location {
            id
            title
          }
        }
        parentRoleId
        parentRole {
          id
          name
        }
        createdBy {
          id
          fullName
        }
        updatedBy {
          id
          fullName
        }
        users {
          id
          fullName
        }
        createTs
        updateTs
      }
    }
  }
`;
export const UPDATE_COMPANY_ROLE = gql`
  mutation UpdateCompanyRole(
    $companyRoleId: Int!
    $name: String!
    $parentRoleId: Int
    $permissionActionIds: [Int]
    $permissionLocationIds: [Int]
    $locationId: Int
    $isOpenCrmWarningPopup: Boolean
    $isActive: Boolean
    $permissionActionLocationObjs: [PermissionActionLocationObj]
  ) {
    updateCompanyRole(
      companyRoleId: $companyRoleId
      name: $name
      parentRoleId: $parentRoleId
      permissionActionIds: $permissionActionIds
      permissionLocationIds: $permissionLocationIds
      locationId: $locationId
      isOpenCrmWarningPopup: $isOpenCrmWarningPopup
      isActive: $isActive
      permissionActionLocationObjs: $permissionActionLocationObjs
    ) {
      statusCode
      message
      companyRole {
        id
        name
        isOpenCrmWarningPopup
        companyId
        parentRoleId
        isSmaiRole
        isActive
        locations {
          location {
            id
            title
          }
        }
      }
    }
  }
`;

export const DELETE_COMPANY_ROLE = gql`
  mutation DeleteCompanyRole($companyRoleId: Int!) {
    deleteCompanyRole(companyRoleId: $companyRoleId) {
      statusCode
      message
    }
  }
`;

export const UPDATE_COMPANY_CONSENT_TEMPLATE = gql`
  mutation updateCompanyConsentTemplateEvent(
    $companyId: Int!
    $companyConsentTemplateEventInputs: [CompanyConsentTemplateEventInputs]!
  ) {
    updateCompanyConsentTemplateEvent(
      companyId: $companyId
      companyConsentTemplateEventInputs: $companyConsentTemplateEventInputs
    ) {
      statusCode
      message
      companyConsentTemplateEvents {
        consentTemplateEvent {
          id
          code
          title
          isActive
        }
        companyConsentTemplateEvent {
          id
          consentTemplateEventId
          companyId
          templateText
          afterTextMode
          isActive
          onlyFirstMessage
        }
      }
    }
  }
`;
export const UPDATE_COMPANY_REVIEW_TEMPLATE = gql`
  mutation updateCompanyReviewTemplateEvent(
    $companyId: Int!
    $companyReviewTemplateEventInputs: [CompanyReviewTemplateEventInputs]!
  ) {
    updateCompanyReviewTemplateEvent(
      companyId: $companyId
      companyReviewTemplateEventInputs: $companyReviewTemplateEventInputs
    ) {
      statusCode
      message
      companyReviewTemplateEvents {
        reviewTemplateEvent {
          id
          code
          title
          isActive
        }
        companyReviewTemplateEvent {
          id
          reviewTemplateEventId
          companyId
          locationId
          departmentId
          opportunityTypeId
          templateText
          isActive
          department {
            id
            name
          }
          opportunityType {
            id
            name
          }
        }
      }
    }
  }
`;
export const UPDATE_COMPANY_GENERAL_TEMPLATE_SETTINGS = gql`
  mutation updateGeneralSetting(
    $companyId: Int!
    $companyGeneralTemplateSettingInputs: [CompanyGeneralTemplateSettingInputs]!
    $isSendSmsAppointment: Boolean!
    $isSendSmsNewLead: Boolean!
    $isSendSmsSoldLead: Boolean!
    $isSendEmailAppointment: Boolean!
    $isSendEmailNewLead: Boolean!
    $isSendEmailSoldLead: Boolean!
  ) {
    updateGeneralSetting(
      companyId: $companyId
      companyGeneralTemplateSettingInputs: $companyGeneralTemplateSettingInputs
      isSendSmsAppointment: $isSendSmsAppointment
      isSendSmsNewLead: $isSendSmsNewLead
      isSendSmsSoldLead: $isSendSmsSoldLead
      isSendEmailAppointment: $isSendEmailAppointment
      isSendEmailNewLead: $isSendEmailNewLead
      isSendEmailSoldLead: $isSendEmailSoldLead
    ) {
      statusCode
      message
      companyGeneralTemplateSettingEvents {
        generalTemplateSettingEvent {
          id
          code
          title
          isActive
        }
        companyGeneralTemplateSetting {
          id
          templateText
          isNudge
          isAppointment
          isConsent
          isReview
          isOtto
          isActive
        }
      }
      crmIntegrationSetting {
        id
        crmIntegrationId
        isSendSmsAppointment
        isSendSmsSoldLead
        isSendSmsNewLead
        isSendEmailAppointment
        isSendEmailSoldLead
        isSendEmailNewLead
      }
    }
  }
`;
export const CREATE_LEAD_VEHICLE_INVENTORY = gql`
  mutation createDsLeadVehicleInventory($leadId: Int!, $dsVehicleInventoryId: Int!) {
    createDsLeadVehicleInventory(leadId: $leadId, dsVehicleInventoryId: $dsVehicleInventoryId) {
      statusCode
      message
      dsLeadVehicleInventory {
        id
        dsVehicleInventoryId
        leadVehicleOfInterestId
      }
    }
  }
`;

export const DELETE_LEAD_VEHICLE_INVENTORY = gql`
  mutation deleteDsLeadVehicleInventory($leadVehicleOfInterestId: Int!) {
    deleteDsLeadVehicleInventory(leadVehicleOfInterestId: $leadVehicleOfInterestId) {
      statusCode
      message
    }
  }
`;
export const RETRY_MESSAGE_SEND = gql`
  mutation retryMessage($messageId: Int!) {
    retryMessage(messageId: $messageId) {
      statusCode
      message
      leadMessage {
        id
        systemUserId
        leadId
        userId
        channelId
        campaignId
        campaignTemplateId
        direction
        dateSent
        dateReceived
        content
        errorCode
        errorMessage
        statusCode
        messageStatus
        messageType
        messageLog {
          id
          fromPhone
          toPhone
        }
      }
    }
  }
`;

export const EDIT_USER_LOCATION = gql`
  mutation sendLeadToStore($leadId: Int!, $locationId: Int!) {
    sendLeadToStore(leadId: $leadId, locationId: $locationId, isSyncCheck: true, isPushCrm: true) {
      statusCode
      message
      lead {
        id
        firstName
        lastName
        location {
          id
          title
        }
      }
    }
  }
`;
export const CREATE_OPPORTUNITY = gql`
  mutation createLeadOpportunity(
    $leadId: Int!
    $opportunityTypeId: Int!
    $opportunityStatusId: Int!
    $name: String!
  ) {
    createLeadOpportunity(
      leadId: $leadId
      opportunityTypeId: $opportunityTypeId
      name: $name
      opportunityStatusId: $opportunityStatusId
    ) {
      statusCode
      message
      leadOpportunity {
        id
        name
        opportunityType {
          id
          name
          parentType {
            id
            name
          }
        }
        opportunityStatus {
          id
          name
          parentStatus {
            id
            name
          }
        }
      }
    }
  }
`;
export const UPDATE_USER_PHONE = gql`
  mutation updateUserPhone($phone: String!) {
    updateUserPhone(phone: $phone) {
      statusCode
      message
      user {
        id
        phone
      }
    }
  }
`;

export const CREATE_COMPANY_LEAD_SOURCE = gql`
  mutation createCompanyLeadSource(
    $companyId: Int!
    $consentOption: String!
    $name: String!
    $parentId: Int
  ) {
    createCompanyLeadSource(
      companyId: $companyId
      consentOption: $consentOption
      name: $name
      parentId: $parentId
    ) {
      statusCode
      message
      leadSource {
        id
        name
        parentSource {
          id
          name
        }
      }
      companyLeadSource {
        id
        consentOption
      }
    }
  }
`;
export const UPDATE_COMPANY_LEAD_SOURCE = gql`
  mutation updateCompanySourceConsentOption(
    $emails: [String]!
    $companySourceConsentOptions: [CompanySourceConsentOption]
    $companyId: Int!
  ) {
    updateCompanySourceConsentOption(
      emails: $emails
      companySourceConsentOptions: $companySourceConsentOptions
      companyId: $companyId
    ) {
      statusCode
      message
    }
  }
`;

export const PULL_LEAD_FROM_CRM = gql`
  mutation pullCrmLead(
    $locationId: Int!
    $crmLeadId: String
    $crmAppointmentId: String
    $oppType: String
  ) {
    pullCrmLead(
      locationId: $locationId
      crmLeadId: $crmLeadId
      crmAppointmentId: $crmAppointmentId
      oppType: $oppType
    ) {
      statusCode
      message
      lead {
        id
        fullName
        companyId
        leadStatusTypeId
        campaignAutoResponse
        consentExpireDay
        textConsentDate
        preferredLanguageCode
        textConsentStatus
        crmLeadObj {
          crmStatus
          parentCrmStatus
          activeLeadOpportunity {
            id
            opportunityStatus {
              id
              name
              parentStatus {
                id
                name
              }
            }
            opportunitySource {
              id
              name
              parentSource {
                id
                name
                parentSource {
                  id
                  name
                }
              }
            }
            vehiclesOfInterest {
              id
              leadId
              year
              make
              model
              trim
              description
              budget
              customerInterest
              inputType
              isCurrent
              isPrimary
              stockNumber
              vin
            }
          }
          dsExtractedLead {
            id
            dsLeadId
            dsSource
          }
          sfExtractedLead {
            id
            sfLeadId
          }
          mfExtractedLead {
            id
            mfProspectId
            mfCustomerId
          }
          dtExtractedLead {
            id
            dtLeadId
          }
        }
        leadStatusType {
          id
          type
        }

        leadSource {
          name
          id
          parentSource {
            id
            name
            parentSource {
              id
              name
            }
          }
        }
        location {
          id
          title
          locationType
          timezone
          settings
        }
        leadUsers {
          userType {
            id
            useCase
            name
          }
          user {
            id
            firstName
            lastName
            companyRole {
              id
              name
            }
          }
        }
        emails {
          id
          email
          emailType
          isPrimary
          relationshipType
          firstName
          lastName
          note
        }
        phoneNumbers {
          id
          phone
          phoneType
          lookupType
          potentialLeads
          isPrimary
          relationshipType
          firstName
          lastName
          note
        }
        addresses {
          id
          addressLine1
          addressLine2
          city
          state
          postalCode
          country
        }
        leadVehicleInventory {
          id
          make
          model
          year
          trim
          stockNumber
          vin
        }
        conversationStatus {
          id
          disableConversation
          createdOn
        }
        leadOpportunities {
          id
          name
          createdDate
          updatedDate
          potentialOpportunity
          opportunityMergeHistory
          isActive
          location {
            id
            title
          }
          leadOpportunityUsers {
            id
            userTypeId
            userId
            isActive
            user {
              id
              fullName
              companyRole {
                id
                name
              }
            }
            userType {
              name
            }
          }
          vehiclesOfInterest {
            id
            leadId
            year
            make
            model
            trim
            description
            budget
            customerInterest
            inputType
            isCurrent
            isPrimary
            stockNumber
            vin
          }
          opportunityTypeId
          opportunityStatusId
          opportunitySourceId
          opportunityType {
            id
            name
          }
          opportunityStatus {
            id
            name
          }
          opportunitySource {
            id
            name
            parentSource {
              id
              name
              parentSource {
                id
                name
              }
            }
          }
          location {
            id
            title
          }
          lead {
            id
            location {
              id
              title
            }
          }
          dtLeadOpportunities {
            id
            dtLeadSource {
              dtLeadSourceName
              leadSource {
                id
                name
              }
            }
            dtLeadStatusMapping {
              leadStatusType {
                id
                type
                status
              }
              dtLeadStatus
            }
          }
          dsOpportunityEvents {
            id
            dsEventId
            dsLeadId
            dsEntitySource
            dsMarketingChannelName
            dsTrackingCode
            leadSource {
              name
            }
          }
          sfLeadOpportunities {
            id
            sfOpportunityId
            sfOpportunityStage
          }
          vsLeadOpportunities {
            id
            vsContactId
            vsLeadId
            vsLeadStatusMapping {
              vsLeadStatusType
              vsLeadStatus
            }
          }
          elLeadOpportunities {
            id
            elOpportunityId
            elLeadId
          }
          mfLeadOpportunities {
            id
            mfProspectId
            mfCustomerId
            mfLeadId
          }
          dtLeadOpportunities {
            id
            dtOpportunityId
            dtOpportunityStage
          }
          opportunityStatus {
            id
            name
            parentStatus {
              name
              id
            }
          }
          statusHistory {
            id
            newStatus {
              id
              name
              parentStatus {
                id
                name
                parentStatus {
                  id
                  name
                }
              }
            }
            oldStatus {
              id
              name
            }
            isTransferred
            createTs
            statusChangedTs
            statusChangedBy {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;
export const UPDATE_OPPORTUNITY_STAGE_NAME = gql`
  mutation updateSfLeadStage($leadOpportunityId: Int!, $stageName: String!) {
    updateSfLeadStage(leadOpportunityId: $leadOpportunityId, stageName: $stageName) {
      statusCode
      message
    }
  }
`;

export const OPPORTUNITY_REDIRECTION_DIALOG = gql`
  mutation updateOpenCrmWarningPopup($locationId: Int!, $isOpenCrmWarningPopup: Boolean!) {
    updateOpenCrmWarningPopup(
      locationId: $locationId
      isOpenCrmWarningPopup: $isOpenCrmWarningPopup
    ) {
      statusCode
      message
    }
  }
`;

export const CREATE_LEAD_Without_Phone_Lookup = gql`
  mutation createLeadWithoutPhoneLookup(
    $fullName: String!
    $leadSourceType: String!
    $firstName: String
    $lastName: String
    $leadSourceOriginalId: Int
    $phone: String
    $leadStatusTypeId: Int
    $leadStatusDescription: String
    $otherSource: String
    $isSyncCheck: Boolean
    $isPushCrm: Boolean
    $primaryOwnerId: Int
    $ownerIds: [UserMapping]
  ) {
    createLeadWithoutPhoneLookup(
      fullName: $fullName
      leadSourceType: $leadSourceType
      firstName: $firstName
      lastName: $lastName
      leadSourceOriginalId: $leadSourceOriginalId
      phone: $phone
      leadStatusTypeId: $leadStatusTypeId
      leadStatusDescription: $leadStatusDescription
      otherSource: $otherSource
      isSyncCheck: $isSyncCheck
      isPushCrm: $isPushCrm
      primaryOwnerId: $primaryOwnerId
      ownerIds: $ownerIds
    ) {
      statusCode
      message
      lead {
        id
        fullName
        firstName
        lastName
        dateOfBirth
        leadSourceType
        leadSourceOriginalId
        companyId
        leadFileId
        crmIntegrationId
        status
        emailConsent
        emailConsentDate
        textConsent
        textConsentDate
        textConsentStatus
        otherSource
        leadStatusTypeId
        leadStatusType {
          id
          type
          status
        }
        emails {
          id
          leadId
          email
          emailType
          isPrimary
          firstName
          lastName
          relationshipType
        }
        phoneNumbers {
          id
          leadId
          phone
          phoneType
          lookupType
          isPrimary
          firstName
          lastName
          relationshipType
        }
        addresses {
          id
          leadId
          locationText
          addressLine1
          addressLine2
          city
          state
          postalCode
          country
        }
        vehicleOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
          customerInterest
          inputType
          isCurrent
          isPrimary
          stockNumber
          vin
        }
        leadSource {
          id
          name
        }
        leadUsers {
          userType {
            id
            useCase
            name
          }
          user {
            id
            email
            firstName
            lastName
            companyRole {
              id
              name
            }
          }
        }
      }
    }
  }
`;
export const CREATE_LEAD_PHONE_WITHOUT_LOOKUP = gql`
  mutation createLeadPhoneWithoutPhoneLookup(
    $leadId: Int!
    $phone: String!
    $phoneType: String
    $isSyncCheck: Boolean
    $isPushCrm: Boolean
  ) {
    createLeadPhoneWithoutPhoneLookup(
      leadId: $leadId
      phone: $phone
      phoneType: $phoneType
      isSyncCheck: $isSyncCheck
      isPushCrm: $isPushCrm
    ) {
      statusCode
      message
      leadPhone {
        id
        phone
        phoneType
      }
    }
  }
`;
export const ADD_REVIEW_TAGS = gql`
  mutation createReviewUser($reviewId: Int!, $taggedUserIds: [Int]) {
    createReviewUser(reviewId: $reviewId, taggedUserIds: $taggedUserIds) {
      statusCode
      message
    }
  }
`;

export const CREATE_MMS = gql`
  mutation createMms(
    $userId: Int!
    $replyAsUserId: Int
    $leadId: Int!
    $channelId: Int
    $campaignId: Int
    $campaignTemplateId: Int
    $direction: String
    $content: String
    $toPhone: String!
    $reviewLink: String
    $leadOpportunityId: Int
    $systemUserId: Int
    $mmsObjects: [Media]!
    $selectedOppTypeId: Int
    # $aiResponseHistoryId: Int
    $attachmentSource: String
  ) {
    createMms(
      leadId: $leadId
      userId: $userId
      replyAsUserId: $replyAsUserId
      channelId: $channelId
      campaignId: $campaignId
      campaignTemplateId: $campaignTemplateId
      direction: $direction
      content: $content
      toPhone: $toPhone
      reviewLink: $reviewLink
      leadOpportunityId: $leadOpportunityId
      systemUserId: $systemUserId
      medias: $mmsObjects
      selectedOppTypeId: $selectedOppTypeId
      # aiResponseHistoryId: $aiResponseHistoryId
      attachmentSource: $attachmentSource
    ) {
      statusCode
      message
      leadMessage {
        id
        systemUserId
        hasLinkTracking
        leadId
        userId
        originalUserId
        channelId
        campaignId
        campaignTemplateId
        direction
        dateSent
        dateReceived
        content
        messageType
        errorCode
        errorMessage
        statusCode
        messageStatus
        leadOpportunityId
        messageLog {
          id
          fromPhone
          toPhone
        }
        user {
          firstName
          lastName
          profilePic
          companyRole {
            name
          }
          phone
          email
        }
        mmsObjects {
          id
          mediaUrl
          compressedMediaUrl
          thumbnail
          size
          mediaType
        }
        leadOpportunity {
          id
          name
          opportunityType {
            id
            name
            parentType {
              id
              name
            }
          }
          opportunityStatus {
            id
            name
            parentStatus {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const CREATE_GENERIC_FILTER = gql`
  mutation createGenericFilter(
    $filterJson: String!
    $filterName: String
    $isCurrent: Boolean
    $genericFilterTypeId: Int!
  ) {
    createGenericFilter(
      filterJson: $filterJson
      filterName: $filterName
      isCurrent: $isCurrent
      genericFilterTypeId: $genericFilterTypeId
    ) {
      statusCode
      message
      genericFilters {
        id
        filterName
        genericFilterTypeId
        genericFilterJson {
          id
          genericFilterId
          filterJson
        }
      }
    }
  }
`;

export const CREATE_WEB_CHAT_WIDGET = gql`
  mutation createWebChatWidget(
    $companyId: Int!
    $initialText: String
    $isPhoneRequired: Boolean!
    $locationId: Int
    $presetQuestionInd: Boolean!
    $questions: [GenericScalar]
    $switchToSmsInd: Boolean!
    $userIds: [Int]
    $teamId: Int
    $origins: [String]
    $indicationMethodCode: String!
    $metaData: GenericScalar
  ) {
    createWebChatWidget(
      companyId: $companyId
      initialText: $initialText
      isPhoneRequired: $isPhoneRequired
      locationId: $locationId
      presetQuestionInd: $presetQuestionInd
      questions: $questions
      switchToSmsInd: $switchToSmsInd
      userIds: $userIds
      teamId: $teamId
      origins: $origins
      indicationMethodCode: $indicationMethodCode
      metaData: $metaData
    ) {
      statusCode
      message
      webChatWidget {
        widgetUid
      }
    }
  }
`;

export const UPDATE_GENERIC_FILTER = gql`
  mutation updateGenericFilter(
    $filterJson: String
    $id: Int
    $filterName: String
    $isCurrent: Boolean
    $genericFilterTypeId: Int
  ) {
    updateGenericFilter(
      filterJson: $filterJson
      id: $id
      filterName: $filterName
      isCurrent: $isCurrent
      genericFilterTypeId: $genericFilterTypeId
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_WEB_CHAT_WIDGET = gql`
  mutation updateWebChatWidget(
    $id: Int!
    $initialText: String
    $isPhoneRequired: Boolean!
    $presetQuestionInd: Boolean!
    $questions: [GenericScalar]
    $switchToSmsInd: Boolean!
    $userIds: [Int]
    $teamId: Int
    $isActive: Boolean
    $origins: [String]
    $indicationMethodCode: String!
    $metaData: GenericScalar
  ) {
    updateWebChatWidget(
      id: $id
      initialText: $initialText
      isPhoneRequired: $isPhoneRequired
      presetQuestionInd: $presetQuestionInd
      questions: $questions
      switchToSmsInd: $switchToSmsInd
      userIds: $userIds
      teamId: $teamId
      isActive: $isActive
      origins: $origins
      indicationMethodCode: $indicationMethodCode
      metaData: $metaData
    ) {
      statusCode
      message
      webChatWidget {
        widgetUid
      }
    }
  }
`;
export const DELETE_WEB_CHAT_WIDGET = gql`
  mutation deleteWebChatWidget($id: Int!) {
    deleteWebChatWidget(id: $id) {
      statusCode
      message
    }
  }
`;
export const DELETE_GENERIC_FILTER = gql`
  mutation deleteGenericFilter($id: Int!) {
    deleteGenericFilter(id: $id) {
      statusCode
      message
    }
  }
`;

export const CREATE_DUPLICATE_LEAD = gql`
  mutation createDuplicateLead($leadId: Int, $locationId: Int) {
    createDuplicateLead(leadId: $leadId, locationId: $locationId) {
      statusCode
      message
    }
  }
`;

export const UPDATE_APPOINTMENT_STATUS = gql`
  mutation updateAppointmentStatus(
    $appointmentId: Int!
    $latestAppointmentStatus: String!
    $leadId: Int!
    $userId: Int!
  ) {
    updateAppointmentStatus(
      appointmentId: $appointmentId
      latestAppointmentStatus: $latestAppointmentStatus
      leadId: $leadId
      userId: $userId
    ) {
      appointment {
        id
      }
      statusCode
      message
    }
  }
`;
export const UPDATE_APPOINTMENT_STATUS_WITH_TOKEN = gql`
  mutation updateAppointmentStatusWithToken(
    $appointmentToken: String!
    $newAppointmentStatus: String!
  ) {
    updateAppointmentStatusWithToken(
      appointmentToken: $appointmentToken
      newAppointmentStatus: $newAppointmentStatus
    ) {
      statusCode
      message
      redirectUrl
    }
  }
`;
//  If not found dsLeadId, firstName,lastName , dont call this mutation

export const ADD_LEAD_FROM_EXTENSION = gql`
  mutation addLeadFromExtension(
    $dsLeadId: String
    $firstName: String!
    $lastName: String!
    $location: String!
    $phone: String!
    $userId: Int!
  ) {
    addLeadFromExtension(
      dsLeadId: $dsLeadId
      firstName: $firstName
      lastName: $lastName
      location: $location
      phone: $phone
      userId: $userId
    ) {
      statusCode
      message
    }
  }
`;

export const OPT_OUT_LEAD = gql`
  mutation optOutLead($leadId: Int!) {
    optOutLead(leadId: $leadId) {
      statusCode
      message
    }
  }
`;

export const SAVE_NOTIFICATION_CONFIG = gql`
  mutation SaveNotificationConfig(
    $notificationsAllowed: Boolean!
    $id: Int
    $dndStart: Time
    $dndEnd: Time
    $timezone: String
    $app: Boolean
    $sms: Boolean
    $responses: Boolean
    $email: Boolean
    $interval: String
    $details: [NotificationConfigDetailInputs]
  ) {
    saveNotificationConfig(
      notificationsAllowed: $notificationsAllowed
      id: $id
      dndStart: $dndStart
      dndEnd: $dndEnd
      timezone: $timezone
      app: $app
      sms: $sms
      responses: $responses
      email: $email
      interval: $interval
      details: $details
    ) {
      ok
    }
  }
`;
export const CREATE_REVIEW_RESPONSE = gql`
  mutation createReviewResponse($comment: String!, $reviewId: Int!) {
    createReviewResponse(
      comment: $comment

      reviewId: $reviewId
    ) {
      statusCode
      message
      reviewResponse {
        id
        message
      }
    }
  }
`;
export const UPDATE_REVIEW_RESPONSE = gql`
  mutation updateReviewResponse($comment: String!, $id: Int!) {
    updateReviewResponse(comment: $comment, id: $id) {
      statusCode
      message
      reviewResponse {
        id
        message
      }
    }
  }
`;
export const CREATE_SOCIAL_REVIEW_SETTING = gql`
  mutation createSocialReviewSetting(
    $companyId: Int!
    $locationId: Int
    $departmentId: Int
    $opportunityTypeId: Int
    $platform: String!
    $accountId: String
    $accessToken: String
    $reviewPostUrl: String
    $platformUrl: String
    $accountLocationId: String
    $isOauthConnected: Boolean
    $siteName: String
    $isPrimary: Boolean
    $readOnlyFacebookPagesFetch: Boolean
    $pageId: String
    $pageName: String
  ) {
    createSocialReviewSetting(
      companyId: $companyId
      locationId: $locationId
      departmentId: $departmentId
      opportunityTypeId: $opportunityTypeId
      platform: $platform
      accountId: $accountId
      accessToken: $accessToken
      reviewPostUrl: $reviewPostUrl
      platformUrl: $platformUrl
      accountLocationId: $accountLocationId
      isOauthConnected: $isOauthConnected
      siteName: $siteName
      isPrimary: $isPrimary
      readOnlyFacebookPagesFetch: $readOnlyFacebookPagesFetch
      pageId: $pageId
      pageName: $pageName
    ) {
      statusCode
      message
      socialReviewSetting {
        id
        companyId
        locationId
        departmentId
        opportunityTypeId
        platform
        platformUrl
        reviewPostUrl
        accessToken
        accountId
        accountLocationId
        isActive
      }
      accounts
      pages
    }
  }
`;

// Save the user's Reviews report export preferences (EAI-1410). Produced by the
// Export Preferences drawer; returns only a status envelope.
export const SAVE_USER_EXPORT_PREFERENCE = gql`
  mutation SaveUserExportPreference(
    $locationId: Int!
    $reportFormat: String
    $includeAppliedFilters: Boolean
    $includeSummarySection: Boolean
    $columns: [String]
  ) {
    saveUserExportPreference(
      locationId: $locationId
      reportFormat: $reportFormat
      includeAppliedFilters: $includeAppliedFilters
      includeSummarySection: $includeSummarySection
      columns: $columns
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_SOCIAL_REVIEW_SETTING = gql`
  mutation updateSocialReviewSetting(
    $socialReviewSettingsId: Int!
    $companyId: Int!
    $locationId: Int
    $departmentId: Int
    $opportunityTypeId: Int
    $platform: String!
    $accountId: String
    $accessToken: String
    $reviewPostUrl: String
    $platformUrl: String
    $accountLocationId: String
    $isActive: Boolean # $readOnlyGoogleAccountFetch: Boolean
    $isOauthConnected: Boolean
    $siteName: String
    $isPrimary: Boolean
    $readOnlyFacebookPagesFetch: Boolean
    $readOnlyGoogleAccountFetch: Boolean
    $pageId: String
    $pageName: String
    $businessName: String
  ) {
    updateSocialReviewSetting(
      socialReviewSettingsId: $socialReviewSettingsId
      companyId: $companyId
      locationId: $locationId
      departmentId: $departmentId
      opportunityTypeId: $opportunityTypeId
      platform: $platform
      accountId: $accountId
      accessToken: $accessToken
      reviewPostUrl: $reviewPostUrl
      platformUrl: $platformUrl
      accountLocationId: $accountLocationId
      isActive: $isActive # readOnlyGoogleAccountFetch: $readOnlyGoogleAccountFetch
      isOauthConnected: $isOauthConnected
      siteName: $siteName
      isPrimary: $isPrimary
      readOnlyFacebookPagesFetch: $readOnlyFacebookPagesFetch
      readOnlyGoogleAccountFetch: $readOnlyGoogleAccountFetch
      pageId: $pageId
      pageName: $pageName
      businessName: $businessName
    ) {
      statusCode
      message
      accounts
      pages
      socialReviewSetting {
        id
        companyId
        locationId
        departmentId
        opportunityTypeId
        platform
        platformUrl
        reviewPostUrl
        accessToken
        accountId
        accountLocationId
        isActive
      }
    }
  }
`;
export const CREATE_AUTH_URL = gql`
  mutation createAuthUrl(
    $companyId: Int!
    $locationId: Int!
    $platform: String!
    $reviewPostUrl: String!
    $isOauthConnected: Boolean
    $isPrimary: Boolean
  ) {
    createAuthUrl(
      companyId: $companyId
      locationId: $locationId
      platform: $platform
      reviewPostUrl: $reviewPostUrl
      isOauthConnected: $isOauthConnected
      isPrimary: $isPrimary
    ) {
      statusCode
      message
      authUrl
    }
  }
`;

export const REVIEW_TRACKING = gql`
  mutation createReviewTracking(
    $actionType: ReviewTrackingActionType
    $actionValue: ReviewTrackingActionValue
    $companyId: Int!
    $leadId: Int
    $locationId: Int
    $userId: Int
    $token: String
  ) {
    createReviewTracking(
      actionType: $actionType
      actionValue: $actionValue
      companyId: $companyId
      locationId: $locationId
      leadId: $leadId
      userId: $userId
      token: $token
    ) {
      statusCode
      message
    }
  }
`;

export const CREATE_SCHEDULED_MESSAGE = gql`
  mutation createScheduledMessage(
    $leadId: Int!
    $scheduledDate: DateTime!
    $timezone: String!
    $message: String!
    $leadOpportunityId: Int
    $selectedOppTypeId: Int
  ) {
    createScheduledMessage(
      leadId: $leadId
      scheduledDate: $scheduledDate
      timezone: $timezone
      message: $message
      leadOpportunityId: $leadOpportunityId
      selectedOppTypeId: $selectedOppTypeId
    ) {
      statusCode
      message
      scheduledMessage {
        id
        leadId
        user {
          fullName
        }
        taskSendDatetime
        message
        timezone
      }
    }
  }
`;

export const UPDATE_SCHEDULED_MESSAGE = gql`
  mutation updateScheduledMessage(
    $id: Int!
    $scheduledDate: DateTime!
    $timezone: String!
    $message: String!
  ) {
    updateScheduledMessage(
      id: $id
      scheduledDate: $scheduledDate
      timezone: $timezone
      message: $message
    ) {
      statusCode
      message
      scheduledMessage {
        id
        leadId
        user {
          fullName
        }
        taskSendDatetime
        message
        timezone
      }
    }
  }
`;

export const DELETE_SCHEDULED_MESSAGE = gql`
  mutation deleteScheduledMessage($id: Int!, $timezone: String!) {
    deleteScheduledMessage(id: $id, timezone: $timezone) {
      statusCode
      message
    }
  }
`;

export const CREATE_REVIEW_LEAD = gql`
  mutation createReviewLead($leadId: Int!, $socialReviewId: Int!) {
    createReviewLead(leadId: $leadId, socialReviewId: $socialReviewId) {
      statusCode
      message
    }
  }
`;
export const DELETE_REVIEW_LEAD = gql`
  mutation deleteReviewLead($socialReviewId: Int!) {
    deleteReviewLead(socialReviewId: $socialReviewId) {
      statusCode
      message
    }
  }
`;
export const CREATE_VDP_LINK_INVENTORY = gql`
  mutation createVdpLinksVehicleInventory($vehicleIds: [Int]!) {
    createVdpLinksVehicleInventory(vehicleIds: $vehicleIds) {
      message
      statusCode
      vdpLinks
    }
  }
`;

export const CREATE_OTTOVIN_LEAD_LINKS = gql`
  mutation createOttoVinLeadLinks(
    $leadId: Int!
    $vehicleIds: [Int]!
    $selectedOppTypeId: Int
    $leadOpportunityId: Int
  ) {
    createOttoVinLeadLinks(
      leadId: $leadId
      vehicleIds: $vehicleIds
      selectedOppTypeId: $selectedOppTypeId
      leadOpportunityId: $leadOpportunityId
    ) {
      message
      statusCode
      links {
        vin
        shortUrl
        destinationUrl
        leadOpportunityId
        error
      }
    }
  }
`;

export const CREATE_OTTOVIN_PRINT_JOB = gql`
  mutation createOttoVinPrintJob(
    $locationId: Int!
    $selection: GenericScalar!
    $layout: String
    $includeImages: Boolean
  ) {
    createOttoVinPrintJob(
      locationId: $locationId
      selection: $selection
      layout: $layout
      includeImages: $includeImages
    ) {
      job
      statusCode
      message
    }
  }
`;

// ---------------------------------------------------------------------------
// Vehicle documents (Inventory → Vehicle Assets tab) — proxied via WebApp-API
// documents_api to the external document-service. `input` / `upload` are opaque
// GenericScalar (the service owns the shapes).
// ---------------------------------------------------------------------------
export const MINT_DOCUMENT_UPLOAD_URL = gql`
  mutation mintDocumentUploadUrl(
    $companyId: Int!
    $mimeType: String!
    $sizeBytes: Int!
    $sha256: String!
    $ext: String
  ) {
    mintDocumentUploadUrl(
      companyId: $companyId
      mimeType: $mimeType
      sizeBytes: $sizeBytes
      sha256: $sha256
      ext: $ext
    ) {
      upload
      statusCode
      message
    }
  }
`;

export const CREATE_DOCUMENT = gql`
  mutation createDocument($companyId: Int!, $input: GenericScalar!, $locationId: Int) {
    createDocument(companyId: $companyId, input: $input, locationId: $locationId) {
      document
      statusCode
      message
    }
  }
`;

export const UPDATE_DOCUMENT = gql`
  mutation updateDocument($companyId: Int!, $documentId: String!, $input: GenericScalar!) {
    updateDocument(companyId: $companyId, documentId: $documentId, input: $input) {
      document
      statusCode
      message
    }
  }
`;

export const DELETE_DOCUMENT = gql`
  mutation deleteDocument($companyId: Int!, $documentId: String!) {
    deleteDocument(companyId: $companyId, documentId: $documentId) {
      statusCode
      message
    }
  }
`;

export const CREATE_CAMPAIGN_V2 = gql`
  mutation createCampaign(
    $activeInd: String
    $campaignLeads: [Int]
    $endDate: DateTime
    $isDisabled: Boolean
    $isPrioritize: Boolean
    $messages: [CampaignMessage]
    $method: String
    $name: String!
    $source: [Int]
    $startDate: DateTime
    $status: [Int]
    $textMessage: String
  ) {
    createCampaign(
      activeInd: $activeInd
      campaignLeads: $campaignLeads
      endDate: $endDate
      isDisabled: $isDisabled
      isPrioritize: $isPrioritize
      messages: $messages
      method: $method
      name: $name
      source: $source
      startDate: $startDate
      status: $status
      textMessage: $textMessage
    ) {
      statusCode
      message
    }
  }
`;
export const UPDATE_LEAD_OPPORTUNITY = gql`
  mutation updateLeadOpportunity(
    $addressType: String
    $dsEntityId: Int
    $dsEventId: Int
    $isPushCrm: Boolean
    $isSyncCheck: Boolean
    $leadOpportunityId: Int!
    $leadOpportunityUsers: [UserMapping]
    $leadSourceType: String
    $locationId: Int
    $opportunityName: String
    $opportunitySourceId: Int
    $opportunityStatusId: Int
    $opportunityTypeId: Int
    $vehicleOfInterests: [VehicleOfInterestInputObject]
    $departmentId: Int
  ) {
    updateLeadOpportunity(
      addressType: $addressType
      dsEntityId: $dsEntityId
      dsEventId: $dsEventId
      isPushCrm: $isPushCrm
      isSyncCheck: $isSyncCheck
      leadOpportunityId: $leadOpportunityId
      leadOpportunityUsers: $leadOpportunityUsers
      leadSourceType: $leadSourceType
      locationId: $locationId
      opportunityName: $opportunityName
      opportunitySourceId: $opportunitySourceId
      opportunityStatusId: $opportunityStatusId
      opportunityTypeId: $opportunityTypeId
      vehicleOfInterests: $vehicleOfInterests
      departmentId: $departmentId
    ) {
      statusCode
      message
    }
  }
`;

export const CREATE_LEAD_OPPORTUNITY = gql`
  mutation createLeadOpportunity(
    $leadId: Int!
    $leadOpportunityUsers: [UserMapping]
    $name: String!
    $opportunityStatusId: Int!
    $opportunityTypeId: Int!
    $locationId: Int
    $opportunitySourceId: Int!
    $vehicleOfInterests: [VehicleOfInterestInputObject]
    $potentialOpportunity: [Int]
    $departmentId: Int
  ) {
    createLeadOpportunity(
      leadId: $leadId
      leadOpportunityUsers: $leadOpportunityUsers
      name: $name
      opportunityStatusId: $opportunityStatusId
      opportunityTypeId: $opportunityTypeId
      locationId: $locationId
      opportunitySourceId: $opportunitySourceId
      vehicleOfInterests: $vehicleOfInterests
      potentialOpportunity: $potentialOpportunity
      departmentId: $departmentId
    ) {
      statusCode
      message
    }
  }
`;

export const DELETE_LEAD_OPPORTUNITY = gql`
  mutation deleteLeadOpportunity($leadOpportunityId: Int!) {
    deleteLeadOpportunity(leadOpportunityId: $leadOpportunityId) {
      statusCode
      message
    }
  }
`;

export const CREATE_PROMPT = gql`
  mutation createPrompt(
    $applicationLevelId: Int!
    $applicationUseCaseId: Int!
    $companyId: Int
    $leadSourceOriginalIds: [Int]
    $locationId: Int
    $promptText: String!
    $companyRoleId: Int
    $teamId: Int
    $userId: Int
  ) {
    createPrompt(
      applicationLevelId: $applicationLevelId
      applicationUseCaseId: $applicationUseCaseId
      companyId: $companyId
      leadSourceOriginalIds: $leadSourceOriginalIds
      locationId: $locationId
      promptText: $promptText
      companyRoleId: $companyRoleId
      teamId: $teamId
      userId: $userId
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_PROMPT = gql`
  mutation updatePrompt(
    $id: Int!
    $leadSourceOriginalIds: [Int]
    $promptText: String!
    $isActive: Boolean
  ) {
    updatePrompt(
      id: $id
      leadSourceOriginalIds: $leadSourceOriginalIds
      promptText: $promptText
      isActive: $isActive
    ) {
      statusCode
      message
    }
  }
`;

export const DELETE_PROMPT = gql`
  mutation deletePrompt($id: Int!) {
    deletePrompt(id: $id) {
      statusCode
      message
    }
  }
`;

// add calenders mutation
export const MODIFIED_COMPANY_SCHEDULE = gql`
  mutation modifyCompanySchedule($companyId: Int, $schedule: WorkingHoursScheduleInput) {
    modifyCompanySchedule(companyId: $companyId, schedule: $schedule) {
      statusCode
      message
    }
  }
`;

export const MODIFIED_LOCATION_SCHEDULE = gql`
  mutation modifyLocationSchedule(
    $isCustom: Boolean
    $locationId: Int
    $schedule: WorkingHoursScheduleInput
  ) {
    modifyLocationSchedule(isCustom: $isCustom, locationId: $locationId, schedule: $schedule) {
      statusCode
      message
    }
  }
`;

export const CREATE_USER_SCHEDULE = gql`
  mutation createUserSchedule(
    $fromDatetime: DateTime
    $isAvailable: Boolean
    $name: String
    $toDatetime: DateTime
    $locationId: Int!
    $isFullDay: Boolean
  ) {
    createUserSchedule(
      fromDatetime: $fromDatetime
      isAvailable: $isAvailable
      name: $name
      toDatetime: $toDatetime
      locationId: $locationId
      isFullDay: $isFullDay
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_USER_SCHEDULE = gql`
  mutation updateUserSchedule(
    $fromDatetime: DateTime
    $id: Int!
    $isAvailable: Boolean
    $name: String
    $toDatetime: DateTime
    $locationId: Int!
    $isFullDay: Boolean
  ) {
    updateUserSchedule(
      fromDatetime: $fromDatetime
      id: $id
      isAvailable: $isAvailable
      name: $name
      toDatetime: $toDatetime
      locationId: $locationId
      isFullDay: $isFullDay
    ) {
      statusCode
      message
    }
  }
`;

export const DELETE_USER_SCHEDULE = gql`
  mutation deleteUserSchedule($id: Int) {
    deleteUserSchedule(id: $id) {
      statusCode
      message
    }
  }
`;

export const UPDATE_USER_WORKING_HOURS = gql`
  mutation updateUserWorkingHours($inputWorkingHours: [WorkingHourInputs]!, $locationId: Int!) {
    updateUserWorkingHours(inputWorkingHours: $inputWorkingHours, locationId: $locationId) {
      statusCode
      message
      workingHours {
        id
        userId
        weekDay
        isWorkingDay
        startTime
        endTime
        createdOn
        isActive
        isDeleted
        user {
          id
          email
          firstName
          lastName
          companyId
        }
      }
    }
  }
`;
// end add calenders mutation

export const DELETE_NOTIFICATIONS = gql`
  mutation deleteNotification($notificationIds: [Int]) {
    deleteNotification(notificationIds: $notificationIds) {
      statusCode
      message
    }
  }
`;

// Pinned leads (EAI-1765). Server-side, per (user, location) — a pin is never
// visible to another user. Both take a list so single and bulk share one path.
//
// pinLeads is idempotent: ids already pinned, or unknown/deleted/cross-company,
// come back in `skippedIds` instead of erroring, so one stale id never fails
// the batch. Newly pinned ids go to the FRONT, newest first — pinning [A, B]
// leaves B above A. The payload also carries a `pinnedCount`; nothing selects
// it, because pin order no longer affects the lead list and the Pinned tab
// reads its own total off getLeads.
//
// `locationId` is REQUIRED (Int!) — the backend deliberately refuses to guess,
// since resolving it server-side could store the pin at a rooftop the user
// wasn't looking at. Callers send the top-bar location when one is selected,
// else the lead's own `location.id`. Note unpinLeads keeps it optional.
export const PIN_LEADS = gql`
  mutation pinLeads($leadIds: [Int]!, $locationId: Int!) {
    pinLeads(leadIds: $leadIds, locationId: $locationId) {
      statusCode
      message
      pinnedIds
      skippedIds
    }
  }
`;

// `leadIds` and `unpinAll` are mutually exclusive — sending both, or neither,
// is a 400. unpinAll exists so clearing hundreds of pins doesn't mean sending
// every id back.
export const UNPIN_LEADS = gql`
  mutation unpinLeads($leadIds: [Int], $locationId: Int, $unpinAll: Boolean) {
    unpinLeads(leadIds: $leadIds, locationId: $locationId, unpinAll: $unpinAll) {
      statusCode
      message
      unpinnedIds
    }
  }
`;

export const BROADCAST_UNREAD_COUNT = gql`
  mutation updateUnreadCount($leadId: Int) {
    updateUnreadCount(leadId: $leadId) {
      statusCode
      unreadCount
      message
    }
  }
`;

export const TRANSLATE_MESSAGE = gql`
  mutation translateMessage(
    $content: String!
    $sourceLanguage: String
    $targetLanguage: String
    $messageId: Int
  ) {
    translateMessage(
      content: $content
      sourceLanguage: $sourceLanguage
      targetLanguage: $targetLanguage
      messageId: $messageId
    ) {
      statusCode
      message
      translatedContent
    }
  }
`;

export const UPDATE_LEAD_PREFFREDLANGUAGE = gql`
  mutation updateLeadPreferredLanguage($leadId: Int!, $preferredLanguageCode: String!) {
    updateLeadPreferredLanguage(leadId: $leadId, preferredLanguageCode: $preferredLanguageCode) {
      statusCode
      message
      preferredLanguageCode
    }
  }
`;

export const UPDATE_TRANSLATION_SETTINGS = gql`
  mutation modifyTranslationSetting(
    $customerLanguage: String
    $userLanguage: String
    $isAutomaticTranslation: Boolean
    $isIncludeOriginalMessage: Boolean
    $isTranslationPreview: Boolean
    $leadId: Int!
  ) {
    modifyTranslationSetting(
      customerLanguage: $customerLanguage
      userLanguage: $userLanguage
      isAutomaticTranslation: $isAutomaticTranslation
      isIncludeOriginalMessage: $isIncludeOriginalMessage
      isTranslationPreview: $isTranslationPreview
      leadId: $leadId
    ) {
      statusCode
      message
      translationSetting {
        customerLanguage
        userLanguage
        isAutomaticTranslation
        isIncludeOriginalMessage
        isTranslationPreview
      }
    }
  }
`;

export const UPDATE_LEAD_PHONE_LIST = gql`
  mutation updateLead(
    $emails: [LeadEmailsObj]
    $firstName: String
    $isNoResponseNeeded: Boolean
    $isPushCrm: Boolean
    $isSyncCheck: Boolean
    $lastName: String
    $leadAddressObj: LeadAddressInputObj
    $leadId: Int!
    $phones: [LeadPhonesObj]
  ) {
    updateLead(
      emails: $emails
      firstName: $firstName
      isNoResponseNeeded: $isNoResponseNeeded
      isPushCrm: $isPushCrm
      isSyncCheck: $isSyncCheck
      lastName: $lastName
      leadAddressObj: $leadAddressObj
      leadId: $leadId
      phones: $phones
    ) {
      statusCode
      message
      lead {
        id
        phoneNumbers {
          id
          phone
          phoneType
          lookupType
          isPrimary
          firstName
          lastName
          relationshipType
        }
        emails {
          id
          email
          emailType
          isPrimary
          firstName
          lastName
          relationshipType
        }
        textConsentStatus
        textConsent
        textConsentDate
      }
    }
  }
`;

export const CREATE_NOTE = gql`
  mutation createNote(
    $leadId: Int!
    $leadOpportunityId: Int
    $note: String!
    $noteType: LeadNotesType!
    $userId: Int
    $voiceNotes: [VoiceNotesInput]
  ) {
    createNote(
      leadId: $leadId
      leadOpportunityId: $leadOpportunityId
      note: $note
      noteType: $noteType
      userId: $userId
      voiceNotes: $voiceNotes
    ) {
      message
      statusCode
      leadNote {
        id
        leadId
        leadOpportunity {
          id
          name
        }
        note
        createTs
        updateTs
        createdBy {
          id
          fullName
        }
        voiceNotes {
          id
          voiceNote
        }
      }
    }
  }
`;
export const DELETE_NOTE = gql`
  mutation deleteNote($id: Int!) {
    deleteNote(id: $id) {
      message
      statusCode
    }
  }
`;
export const UPDATE_NOTE = gql`
  mutation updateNote(
    $id: Int!
    $leadId: Int
    $leadOpportunityId: Int
    $note: String
    $noteType: LeadNotesType!
    $userId: Int
    $voiceNotes: [VoiceNotesInput]
  ) {
    updateNote(
      id: $id
      leadId: $leadId
      leadOpportunityId: $leadOpportunityId
      note: $note
      noteType: $noteType
      userId: $userId
      voiceNotes: $voiceNotes
    ) {
      message
      statusCode
      leadNote {
        id
        leadId
        leadOpportunity {
          id
          name
        }
        note
        createTs
        updateTs
        createdBy {
          id
          fullName
        }
        voiceNotes {
          id
          voiceNote
        }
      }
    }
  }
`;

export const UPDATE_DEPARTMENT = gql`
  mutation updateDepartment(
    $addressLine1: String
    $addressLine2: String
    $city: String
    $country: String
    $departmentId: Int!
    $email: String
    $geoLink: String
    $isActive: Boolean
    $isDefault: Boolean!
    $name: String!
    $notes: String
    $openaiApiKey: String
    $phone: String
    $postalCode: String
    $state: String
    $website: String
    $users: [UserDepartmentInput]
    $opportunityTypeId: Int
  ) {
    updateDepartment(
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      city: $city
      country: $country
      departmentId: $departmentId
      email: $email
      geoLink: $geoLink
      isActive: $isActive
      isDefault: $isDefault
      name: $name
      notes: $notes
      openaiApiKey: $openaiApiKey
      phone: $phone
      postalCode: $postalCode
      state: $state
      website: $website
      users: $users
      opportunityTypeId: $opportunityTypeId
    ) {
      statusCode
      message
    }
  }
`;

export const CREATE_DEPARTMENT = gql`
  mutation createDepartment(
    $addressLine1: String
    $addressLine2: String
    $city: String
    $country: String
    $email: String
    $geoLink: String
    $isDefault: Boolean!
    $name: String!
    $notes: String
    $phone: String
    $postalCode: String
    $state: String
    $website: String
    $locationId: Int!
    $companyId: Int!
    $userIds: [Int]
    $opportunityTypeId: Int
  ) {
    createDepartment(
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      city: $city
      country: $country
      email: $email
      geoLink: $geoLink
      isDefault: $isDefault
      name: $name
      notes: $notes
      phone: $phone
      postalCode: $postalCode
      state: $state
      website: $website
      locationId: $locationId
      companyId: $companyId
      userIds: $userIds
      opportunityTypeId: $opportunityTypeId
    ) {
      statusCode
      message
    }
  }
`;

export const DELETE_DEPARTMENT = gql`
  mutation deleteDepartment($departmentId: Int!) {
    deleteDepartment(departmentId: $departmentId) {
      statusCode
      message
    }
  }
`;

export const CREATE_LOCATION_HOLIDAY = gql`
  mutation createLocationHoliday(
    $departmentId: Int
    $holidays: [HolidayInput]!
    $isAllDepartments: Boolean
    $locationId: Int!
  ) {
    createLocationHoliday(
      departmentId: $departmentId
      holidays: $holidays
      isAllDepartments: $isAllDepartments
      locationId: $locationId
    ) {
      statusCode
      message
    }
  }
`;

export const DELETE_LOCATION_HOLIDAY = gql`
  mutation deleteLocationHoliday($holidayId: Int!) {
    deleteLocationHoliday(holidayId: $holidayId) {
      statusCode
      message
    }
  }
`;

export const UPDATE_LOCATION_HOLIDAY = gql`
  mutation updateLocationHoliday($holidayId: Int!, $holiday: HolidayInput!) {
    updateLocationHoliday(holidayId: $holidayId, holiday: $holiday) {
      statusCode
      message
    }
  }
`;

export const CREATE_DASHBOARD_SETTING = gql`
  mutation createDashboardSetting(
    $companyId: Int!
    $description: String
    $isActive: Boolean
    $locationIds: [Int]!
    $title: String
  ) {
    createDashboardSetting(
      companyId: $companyId
      description: $description
      isActive: $isActive
      locationIds: $locationIds
      title: $title
    ) {
      statusCode
      message
      dashboardSetting {
        id
        companyId
        extraData
      }
    }
  }
`;
export const MODIFY_DASHBOARD_SECTION = gql`
  mutation modifyDashboardSection(
    $description: String
    $isActive: Boolean
    $key: String
    $name: String
    $sectionId: Int
    $title: String
  ) {
    modifyDashboardSection(
      description: $description
      isActive: $isActive
      key: $key
      name: $name
      sectionId: $sectionId
      title: $title
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_LOCATION_WORKING_HOURS = gql`
  mutation updateLocationWorkingHours(
    $companyId: Int!
    $departmentId: Int
    $inputWorkingHours: [WorkingHourInputs]!
    $isAllDepartments: Boolean
    $locationId: Int!
    $isActive: Boolean
  ) {
    updateLocationWorkingHours(
      companyId: $companyId
      departmentId: $departmentId
      inputWorkingHours: $inputWorkingHours
      isAllDepartments: $isAllDepartments
      locationId: $locationId
      isActive: $isActive
    ) {
      statusCode
      message
    }
  }
`;

export const CLONE_COMPANY_ROLE = gql`
  mutation cloneCompanyRole($roleId: Int!) {
    cloneCompanyRole(roleId: $roleId) {
      statusCode
      message
    }
  }
`;

export const ENABLE_DISABLE_LOCATION_HOLIDAY = gql`
  mutation enableDisableLocationHoliday(
    $companyId: Int!
    $departmentId: Int
    $locationId: Int!
    $isActive: Boolean!
  ) {
    enableDisableLocationHoliday(
      companyId: $companyId
      departmentId: $departmentId
      locationId: $locationId
      isActive: $isActive
    ) {
      statusCode
      message
    }
  }
`;

export const MODIFY_DASHBOARD_SETTING = gql`
  mutation modifyDashboardSetting(
    $companyId: Int!
    $dashboardSettingId: Int
    $description: String
    $isActive: Boolean
    $locationIds: [Int]!
    $sectionId: Int!
    $title: String
  ) {
    modifyDashboardSetting(
      companyId: $companyId
      dashboardSettingId: $dashboardSettingId
      description: $description
      isActive: $isActive
      locationIds: $locationIds
      sectionId: $sectionId
      title: $title
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_LEAD_EMAIL_LIST = gql`
  mutation updateLead($emails: [LeadEmailsObj], $leadId: Int!) {
    updateLead(emails: $emails, leadId: $leadId) {
      statusCode
      message
      lead {
        emails {
          id
          email
          emailType
          isPrimary
          firstName
          lastName
          relationshipType
        }
      }
    }
  }
`;

export const UPDATE_LEAD_CAMPAIGN_CONVERSATION = gql`
  mutation modifyLeadCampaignConversation(
    $campaignIds: [Int]!
    $isDisable: Boolean!
    $leadId: Int!
  ) {
    modifyLeadCampaignConversation(
      campaignIds: $campaignIds
      isDisable: $isDisable
      leadId: $leadId
    ) {
      statusCode
      message
    }
  }
`;

export const MODIFY_EMAIL_CONSENT = gql`
  mutation modifyEmailConsent($leadId: Int, $emailConsent: Boolean) {
    modifyEmailConsent(leadId: $leadId, emailConsent: $emailConsent) {
      statusCode
      message
      lead {
        id
        emailConsent
        emailConsentDate
      }
    }
  }
`;

export const CREATE_LEAD_TASK = gql`
  mutation createLeadTask(
    $assignedTo: Int!
    $completionDate: DateTime
    $description: String!
    $dueDate: DateTime!
    $leadId: Int!
    $taskType: InputTaskType!
    $title: String!
    $leadOpportunityId: Int
  ) {
    createLeadTask(
      assignedTo: $assignedTo
      completionDate: $completionDate
      description: $description
      dueDate: $dueDate
      leadId: $leadId
      taskType: $taskType
      title: $title
      leadOpportunityId: $leadOpportunityId
    ) {
      message
      statusCode
      leadTask {
        id
        taskType
        taskStatus
        title
        description
        lead {
          id
          fullName
          leadOpportunities {
            id
            name
          }
        }
        createdBy {
          id
          fullName
        }
        assignedTo {
          id
          fullName
        }
        completedBy {
          id
          fullName
        }
        dueDate
        completionDate
        completionNote
        leadOpportunityId
      }
    }
  }
`;

export const UPDATE_LEAD_TASK = gql`
  mutation updateLeadTask(
    $assignedTo: Int
    $completionDate: DateTime
    $completionNote: String
    $description: String
    $dueDate: DateTime
    $id: Int!
    $taskStatus: InputTaskStatus
    $taskType: InputTaskType
    $title: String
    $isAnswered: Boolean
    $isCalled: Boolean
    $leadOpportunityId: Int
  ) {
    updateLeadTask(
      assignedTo: $assignedTo
      completionDate: $completionDate
      completionNote: $completionNote
      description: $description
      dueDate: $dueDate
      id: $id
      taskStatus: $taskStatus
      taskType: $taskType
      title: $title
      isAnswered: $isAnswered
      isCalled: $isCalled
      leadOpportunityId: $leadOpportunityId
    ) {
      statusCode
      message
      leadTask {
        id
        taskType
        taskStatus
        title
        description
        lead {
          id
          fullName
          leadOpportunities {
            id
            name
          }
        }
        createdBy {
          id
          fullName
        }
        assignedTo {
          id
          fullName
        }
        completedBy {
          id
          fullName
        }
        dueDate
        completionDate
        completionNote
        leadOpportunityId
      }
    }
  }
`;

export const DELETE_LEAD_TASK = gql`
  mutation deleteLeadTask($taskIds: [Int]!) {
    deleteLeadTask(taskIds: $taskIds) {
      statusCode
      message
    }
  }
`;

export const MODIFY_LEAD_AUTO_RESPONDER = gql`
  mutation modifyLeadAutoResponder($leadId: Int!, $status: CampaignLeadStatusTypeInput!) {
    modifyLeadAutoResponder(leadId: $leadId, status: $status) {
      statusCode
      message
    }
  }
`;

export const CREATE_EMAIL = gql`
  mutation createEmail(
    $attachments: [Media]
    $bcc: [String]
    $campaignId: Int
    $campaignTemplateId: Int
    $cc: [String]
    $channelId: Int
    $content: String!
    $dsEventId: String
    $leadId: Int!
    $leadOpportunityId: Int
    $subject: String!
    $systemUserId: Int
    $userId: Int!
    $replyAsUserId: Int
    $to: String
    $replyToEmailId: Int
    $aiResponseHistoryId: Int
  ) {
    createEmail(
      attachments: $attachments
      bcc: $bcc
      campaignId: $campaignId
      campaignTemplateId: $campaignTemplateId
      cc: $cc
      channelId: $channelId
      content: $content
      dsEventId: $dsEventId
      leadId: $leadId
      leadOpportunityId: $leadOpportunityId
      subject: $subject
      systemUserId: $systemUserId
      userId: $userId
      replyAsUserId: $replyAsUserId
      to: $to
      replyToEmailId: $replyToEmailId
      aiResponseHistoryId: $aiResponseHistoryId
    ) {
      statusCode
      message
      leadMessage {
        id
        systemUserId
        leadId
        userId
        originalUserId
        leadOpportunityId
        user {
          firstName
          lastName
          fullName
          profilePic
          companyRole {
            name
          }
          phone
          email
        }
        # channelId
        # campaignId
        translatedContent
        campaign {
          name
        }
        # campaignTemplateId
        direction
        dateSent
        dateReceived
        content
        translatedContent
        contentType
        messageType
        errorCode
        errorMessage
        # statusCode
        messageStatus
        mmsObjects {
          id
          mediaUrl
          mediaType
          thumbnail
          size
        }
        messageLog {
          id
          messageId
          toPhone
          fromPhone
        }
        trackingDetails {
          id
          actionType
          actionValue
        }
        email {
          id
          from_
          to
          inReplyTo
          subject
          cc
          bcc
          status
          createTs
        }
      }
    }
  }
`;
export const UPDATE_EMAIL_STATUS = gql`
  mutation updateEmailStatus($action: EmailActionType!, $sesMessageIds: [String]!) {
    updateEmailStatus(action: $action, sesMessageIds: $sesMessageIds) {
      statusCode
      message
    }
  }
`;

export const UPDATE_LEAD_ARCHIVE_STATUS = gql`
  mutation updateLeadArchiveStatus($isNoResponseNeeded: Boolean!, $leadId: Int!) {
    updateLeadArchiveStatus(isNoResponseNeeded: $isNoResponseNeeded, leadId: $leadId) {
      statusCode
      message
    }
  }
`;

export const UPDATE_COMPANY_EMAIL_TEMPLATE_EVENT = gql`
  mutation updateCompanyEmailTemplateEvent(
    $companyEmailTemplateEventInputs: [CompanyEmailTemplateEventInputs]!
    $companyId: Int!
    $locationId: Int
    $userId: Int
  ) {
    updateCompanyEmailTemplateEvent(
      companyEmailTemplateEventInputs: $companyEmailTemplateEventInputs
      companyId: $companyId
      locationId: $locationId
      userId: $userId
    ) {
      statusCode
      message
    }
  }
`;

export const DELETE_COMPANY_EMAIL_TEMPLATE_EVENT = gql`
  mutation deleteCompanyEmailTemplateEvent($id: Int!) {
    deleteCompanyEmailTemplateEvent(id: $id) {
      statusCode
      message
    }
  }
`;

export const CREATE_SCHEDULED_EMAIL = gql`
  mutation createScheduledEmail(
    $attachments: [Media]
    $bcc: String
    $body: String!
    $cc: String
    $leadId: Int!
    $replyToEmailId: Int
    $scheduledDate: DateTime!
    $subject: String!
    $timezone: String!
    $to: String
  ) {
    createScheduledEmail(
      attachments: $attachments
      bcc: $bcc
      body: $body
      cc: $cc
      leadId: $leadId
      replyToEmailId: $replyToEmailId
      scheduledDate: $scheduledDate
      subject: $subject
      timezone: $timezone
      to: $to
    ) {
      statusCode
      message
    }
  }
`;

export const SAVE_AS_DRAFT = gql`
  mutation saveAsDraft(
    $body: String
    $companyId: Int!
    $draftType: DraftTypeInput!
    $emailId: Int
    $id: Int
    $leadId: Int!
    $leadOpportunityId: Int
    $locationId: Int!
    $messageId: Int
    $socialReviewId: Int
    $subject: String
    $userId: Int!
    $sender: String
    $receiver: String
  ) {
    saveAsDraft(
      body: $body
      companyId: $companyId
      draftType: $draftType
      emailId: $emailId
      id: $id
      leadId: $leadId
      leadOpportunityId: $leadOpportunityId
      locationId: $locationId
      messageId: $messageId
      socialReviewId: $socialReviewId
      subject: $subject
      userId: $userId
      sender: $sender
      receiver: $receiver
    ) {
      message
      statusCode
    }
  }
`;

export const DELETE_DRAFT = gql`
  mutation deleteDraft($id: Int!) {
    deleteDraft(id: $id) {
      message
      statusCode
    }
  }
`;
export const DELETE_SCHEDULED_EMAIL = gql`
  mutation deleteScheduledEmail($id: Int!, $timezone: String!) {
    deleteScheduledEmail(id: $id, timezone: $timezone) {
      statusCode
      message
    }
  }
`;

export const UPDATE_SCHEDULED_EMAIL = gql`
  mutation updateScheduledEmail(
    $attachments: [Media]
    $bcc: String
    $body: String!
    $cc: String
    $replyToEmailId: Int
    $scheduledDate: DateTime!
    $subject: String!
    $timezone: String!
    $to: String
    $id: Int!
  ) {
    updateScheduledEmail(
      attachments: $attachments
      bcc: $bcc
      body: $body
      cc: $cc
      replyToEmailId: $replyToEmailId
      scheduledDate: $scheduledDate
      subject: $subject
      timezone: $timezone
      to: $to
      id: $id
    ) {
      statusCode
      message
    }
  }
`;

export const MODIFY_SOCIAL_REVIEW_STATUS = gql`
  mutation modifySocialReviewStatus($reviewId: Int!, $isNoResponseNeeded: Boolean) {
    modifySocialReviewStatus(reviewId: $reviewId, isNoResponseNeeded: $isNoResponseNeeded) {
      statusCode
      message
    }
  }
`;

export const UPSERT_DYNAMIC_SETTINGS = gql`
  mutation createOrUpdateDynamicSettings(
    $settingsType: String!
    $companyRoleId: Int
    $userId: Int
    $extraData: GenericScalar
  ) {
    createOrUpdateDynamicSettings(
      settingsType: $settingsType
      companyRoleId: $companyRoleId
      userId: $userId
      extraData: $extraData
    ) {
      statusCode
      message
      companyRolePermissionAction {
        id
        companyRoleId
        isActive
        isCheck
        permissionAction {
          permissionId
          actionId
        }
        extraData
      }
      userPermissionAction {
        id
        userId
        isActive
        isCheck
        permissionAction {
          permissionId
          actionId
        }
        extraData
      }
    }
  }
`;

export const UPDATE_OPPORTUNITY_STATUS = gql`
  mutation modifyOpportunityStatus(
    $companyId: Int!
    $locationId: Int!
    $opportunityTypeId: Int!
    $opportunityStatuses: [OpportunityStatusObject]!
  ) {
    modifyOpportunityStatus(
      companyId: $companyId
      locationId: $locationId
      opportunityTypeId: $opportunityTypeId
      opportunityStatuses: $opportunityStatuses
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_DATA_SERVICE_CONFIG = gql`
  mutation modifyDataServiceConfig(
    $companyId: Int!
    $locationId: Int!
    $dataServiceId: Int!
    $isActive: Boolean!
    $dataServiceConfigId: Int
    $runParams: GenericScalar
  ) {
    modifyDataServiceConfig(
      companyId: $companyId
      locationId: $locationId
      dataServiceId: $dataServiceId
      isActive: $isActive
      dataServiceConfigId: $dataServiceConfigId
      runParams: $runParams
    ) {
      statusCode
      message
      dataServiceConfig {
        id
        companyId
        locationId
        dataService {
          id
          serviceName
        }
        runParams
        createTs
        updateTs
      }
    }
  }
`;

export const DELETE_DATA_SERVICE_CONFIG = gql`
  mutation deleteDataServiceConfig($dataServiceConfigId: Int!) {
    deleteDataServiceConfig(dataServiceConfigId: $dataServiceConfigId) {
      statusCode
      message
    }
  }
`;

export const DELETE_OPPORTUNITY_STATUS = gql`
  mutation deleteOpportunityStatus(
    $companyId: Int!
    $locationId: Int!
    $opportunityStatusId: Int!
  ) {
    deleteOpportunityStatus(
      companyId: $companyId
      locationId: $locationId
      opportunityStatusId: $opportunityStatusId
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_DEFAULT_OPPORTUNITY_STATUS = gql`
  mutation updateDefaultOpportunityStatus($locationId: Int!, $opportunityStatusId: Int!) {
    updateDefaultOpportunityStatus(
      locationId: $locationId
      opportunityStatusId: $opportunityStatusId
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_DYNAMIC_CONFIG_SETTINGS = gql`
  mutation modifyDynamicConfig(
    $code: String!
    $title: String!
    $data: GenericScalar!
    $isActive: Boolean
    $description: String
    $dynamicConfigId: Int
  ) {
    modifyDynamicConfig(
      code: $code
      title: $title
      data: $data
      isActive: $isActive
      description: $description
      dynamicConfigId: $dynamicConfigId
    ) {
      statusCode
      message
      dynamicConfig {
        id
        code
        title
        isActive
        description
        data
      }
    }
  }
`;
export const DELETE_WORKING_HOURS = gql`
  mutation deleteWorkingHours($companyId: Int, $departmentId: Int, $locationId: Int) {
    deleteWorkingHours(
      companyId: $companyId
      departmentId: $departmentId
      locationId: $locationId
    ) {
      statusCode
      message
    }
  }
`;

export const CREATE_AI_SUGGESTION = gql`
  mutation createAiSuggestionQuickTip(
    $applicationUseCaseId: Int!
    $communicationChannels: [String]
    $companyId: Int!
    $departmentId: Int
    $opportunityTypeId: Int
    $description: String
    $isActive: Boolean
    $locationId: Int!
    $suggestionType: String!
    $tip: String!
  ) {
    createAiSuggestionQuickTip(
      applicationUseCaseId: $applicationUseCaseId
      communicationChannels: $communicationChannels
      companyId: $companyId
      departmentId: $departmentId
      opportunityTypeId: $opportunityTypeId
      description: $description
      isActive: $isActive
      locationId: $locationId
      suggestionType: $suggestionType
      tip: $tip
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_AI_SUGGESTION = gql`
  mutation updateAiSuggestionQuickTip(
    $id: Int!
    $tip: String
    $description: String
    $communicationChannels: [String]
    $isActive: Boolean
  ) {
    updateAiSuggestionQuickTip(
      id: $id
      tip: $tip
      description: $description
      isActive: $isActive
      communicationChannels: $communicationChannels
    ) {
      statusCode
      message
    }
  }
`;

export const DELETE_AI_SUGGESTION = gql`
  mutation deleteAiSuggestionQuickTip($id: Int!) {
    deleteAiSuggestionQuickTip(id: $id) {
      statusCode
      message
    }
  }
`;

// Persist a user's Quick Tips / Tones preference for a location (EAI-1497).
// `hidden` = ids the user chose to hide; `preserved` = the user's default selection.
export const SAVE_QUICK_TIPS_PREFERENCE = gql`
  # applicationUseCaseId scopes the saved preference to one surface (message vs
  # review response) — see GET_QUICK_TIPS_PREFERENCE.
  mutation saveQuickTipsPreference(
    $locationId: Int!
    $applicationUseCaseId: Int!
    $quickTips: QuickTipsGroupInput
    $quickTones: QuickTipsGroupInput
  ) {
    saveQuickTipsPreference(
      locationId: $locationId
      applicationUseCaseId: $applicationUseCaseId
      quickTips: $quickTips
      quickTones: $quickTones
    ) {
      statusCode
      message
    }
  }
`;

// Bulk reorder: send the full list as [{ id, order }] with 0-based order.
export const REORDER_AI_SUGGESTIONS = gql`
  mutation reorderAiSuggestionQuickTips($quickTipOrders: [QuickTipOrderInput]!) {
    reorderAiSuggestionQuickTips(quickTipOrders: $quickTipOrders) {
      statusCode
      message
    }
  }
`;

export const MODIFY_MESSAGE_FEEDBACK_OPTIONS = gql`
  mutation modifyMessageFeedbackOptions(
    $companyId: Int!
    $locationId: Int!
    $departmentId: Int
    $isEnableAdditionalComments: Boolean
    $messageFeedbackOptions: [MessageFeedbackOptionsInput]!
    $emails: [String]
  ) {
    modifyMessageFeedbackOptions(
      companyId: $companyId
      locationId: $locationId
      departmentId: $departmentId
      isEnableAdditionalComments: $isEnableAdditionalComments
      messageFeedbackOptions: $messageFeedbackOptions
      emails: $emails
    ) {
      statusCode
      message
    }
  }
`;

export const DELETE_MESSAGE_FEEDBACK_OPTIONS = gql`
  mutation deleteMessageFeedbackOptions(
    $companyId: Int!
    $feedbackOptionId: Int!
    $locationId: Int!
  ) {
    deleteMessageFeedbackOptions(
      companyId: $companyId
      feedbackOptionId: $feedbackOptionId
      locationId: $locationId
    ) {
      statusCode
      message
    }
  }
`;

export const CREATE_MESSAGE_FEEDBACK = gql`
  mutation createMessageFeedback(
    $feedbackOptionIds: [Int]
    # Optional: a DRAFT rating is given before the message exists, so it is
    # keyed by aiResponseHistoryId instead. Exactly one of the two is set.
    $messageId: Int
    $aiResponseHistoryId: Int
    # AUTORESPONDER | CAMPAIGN | DRAFT — see MESSAGE_FEEDBACK_TYPE.
    $feedbackType: String
    $rating: String!
    $additionalComments: String
  ) {
    createMessageFeedback(
      feedbackOptionIds: $feedbackOptionIds
      messageId: $messageId
      aiResponseHistoryId: $aiResponseHistoryId
      feedbackType: $feedbackType
      rating: $rating
      additionalComments: $additionalComments
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_MESSAGE_FEEDBACK = gql`
  mutation updateMessageFeedback(
    $messageFeedbackId: Int!
    $rating: String
    $feedbackOptionIds: [Int]
    $additionalComments: String
    $status: String
    $reviewComment: String
  ) {
    updateMessageFeedback(
      messageFeedbackId: $messageFeedbackId
      rating: $rating
      feedbackOptionIds: $feedbackOptionIds
      additionalComments: $additionalComments
      status: $status
      reviewComment: $reviewComment
    ) {
      statusCode
      message
    }
  }
`;

export const CREATE_MESSAGE_NOTES = gql`
  mutation createMessageNotes(
    $messageId: Int!
    $notes: String!
    $userIds: [Int]!
    $messageForwardOptions: MessageForwardOptionsInput!
  ) {
    createMessageNotes(
      messageId: $messageId
      notes: $notes
      userIds: $userIds
      messageForwardOptions: $messageForwardOptions
    ) {
      statusCode
      message
    }
  }
`;

export const MESSAGE_NOTES_REPLY = gql`
  mutation messageNotesReply(
    $messageNoteId: Int!
    $response: String!
    $messageId: Int!
    $messageForwardOptions: MessageForwardOptionsInput!
  ) {
    messageNotesReply(
      messageNoteId: $messageNoteId
      response: $response
      messageId: $messageId
      messageForwardOptions: $messageForwardOptions
    ) {
      statusCode
      message
    }
  }
`;

export const MODIFY_OPPORTUNITY_SOURCES = gql`
  mutation modifyOpportunitySource(
    $companyId: Int!
    $locationId: Int!
    $opportunitySources: [OpportunitySourceObject]!
  ) {
    modifyOpportunitySource(
      companyId: $companyId
      locationId: $locationId
      opportunitySources: $opportunitySources
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_GOTO_CALL_EXTENSION = gql`
  mutation updateCallExtension(
    $extensionId: Int!
    $userId: Int
    $departmentId: Int
    $departmentLevel: String
    $name: String
    $originalLocationId: Int
  ) {
    updateCallExtension(
      extensionId: $extensionId
      userId: $userId
      departmentId: $departmentId
      departmentLevel: $departmentLevel
      name: $name
      originalLocationId: $originalLocationId
    ) {
      statusCode
      message
      callExtension {
        id
        userId
        departmentId
        departmentLevel
        name
      }
    }
  }
`;

export const UPDATE_GOTO_PHONE_NUMBER = gql`
  mutation updateCallPhoneNumber(
    $phoneNumberId: Int!
    $userId: Int
    $departmentId: Int
    $departmentLevel: String
    $callExtensionId: Int
    $name: String
    $originalLocationId: Int
  ) {
    updateCallPhoneNumber(
      phoneNumberId: $phoneNumberId
      userId: $userId
      departmentId: $departmentId
      departmentLevel: $departmentLevel
      callExtensionId: $callExtensionId
      name: $name
      originalLocationId: $originalLocationId
    ) {
      statusCode
      message
      callPhoneNumber {
        id
        userId
        departmentId
        departmentLevel
        name
      }
    }
  }
`;

export const UPDATE_GOTO_USER = gql`
  mutation updateCallUser(
    $updateUserId: Int!
    $userId: Int
    $departmentId: Int
    $departmentLevel: String
    $originalLocationId: Int
  ) {
    updateCallUser(
      updateUserId: $updateUserId
      userId: $userId
      departmentId: $departmentId
      departmentLevel: $departmentLevel
      originalLocationId: $originalLocationId
    ) {
      statusCode
      message
      callUser {
        id
        userId
        departmentId
        departmentLevel
      }
    }
  }
`;

export const UPDATE_GOTO_CALL_DEVICE = gql`
  mutation updateCallDevice(
    $deviceId: Int!
    $userId: Int
    $departmentId: Int
    $originalLocationId: Int
  ) {
    updateCallDevice(
      deviceId: $deviceId
      userId: $userId
      departmentId: $departmentId
      originalLocationId: $originalLocationId
    ) {
      statusCode
      message
      callDevice {
        id
        userId
        departmentId
        department {
          name
        }
      }
    }
  }
`;

export const SYNC_GOTO_CALL_DATA = gql`
  mutation syncGotoCallData($locationIds: [Int]!) {
    syncGotoCallData(locationIds: $locationIds) {
      statusCode
      message
    }
  }
`;

export const UPDATE_SUPPORTED_LANGUAGE = gql`
  mutation updateSupportedLanguage(
    $companyId: Int!
    $locationId: Int!
    $supportedLanguages: [SupportedLanguageInput]!
  ) {
    updateSupportedLanguage(
      companyId: $companyId
      locationId: $locationId
      supportedLanguages: $supportedLanguages
    ) {
      statusCode
      message
    }
  }
`;

export const DELETE_SOCIAL_REVIEW_PLATFORM = gql`
  mutation deleteSocialReviewSetting($socialReviewSettingsId: Int!) {
    deleteSocialReviewSetting(socialReviewSettingsId: $socialReviewSettingsId) {
      statusCode
      message
    }
  }
`;

export const PUSH_OPPORTUNITY_TO_DMS = gql`
  mutation pushToDms($leadId: Int!, $leadOpportunityId: Int) {
    pushToDms(leadId: $leadId, leadOpportunityId: $leadOpportunityId) {
      statusCode
      message
    }
  }
`;

export const ASSIGN_ABANDONED_CALL_TASK = gql`
  mutation assignAbandonedCallTask(
    $assignedToIds: [Int]!
    $assignmentType: String!
    $leadTaskIds: [Int]!
    $teamId: Int
  ) {
    assignAbandonedCallTask(
      assignedToIds: $assignedToIds
      assignmentType: $assignmentType
      leadTaskIds: $leadTaskIds
      teamId: $teamId
    ) {
      statusCode
      message
    }
  }
`;

export const ACCEPT_ABANDONED_CALL_QUEUED_TASK = gql`
  mutation acceptQueuedTask($leadTaskId: Int!) {
    acceptQueuedTask(leadTaskId: $leadTaskId) {
      statusCode
      message
    }
  }
`;

export const MODIFY_ABANDONED_CALLBACK_STATUS = gql`
  mutation modifyCallbackStatus(
    $completionNotes: String
    $isAnswered: Boolean
    $isCalled: Boolean!
    $leadTaskId: Int!
  ) {
    modifyCallbackStatus(
      completionNotes: $completionNotes
      isAnswered: $isAnswered
      isCalled: $isCalled
      leadTaskId: $leadTaskId
    ) {
      statusCode
      message
    }
  }
`;

export const MODIFY_INVOICE_STATUS = gql`
  mutation modifyInvoiceStatus(
    $companyId: Int!
    $locationId: Int!
    $opportunityTypeId: Int!
    $invoiceStatuses: [InvoiceStatusObject]!
  ) {
    modifyInvoiceStatus(
      companyId: $companyId
      locationId: $locationId
      opportunityTypeId: $opportunityTypeId
      invoiceStatuses: $invoiceStatuses
    ) {
      statusCode
      message
    }
  }
`;

export const DELETE_INVOICE_STATUS = gql`
  mutation deleteInvoiceStatus($companyId: Int!, $locationId: Int!, $invoiceStatusId: Int!) {
    deleteInvoiceStatus(
      companyId: $companyId
      locationId: $locationId
      invoiceStatusId: $invoiceStatusId
    ) {
      statusCode
      message
    }
  }
`;

export const CRATE_DMS_INTEGRATION = gql`
  mutation createDmsIntegration(
    $active: Boolean
    $companyId: Int!
    $dealershipId: Int
    $dmsType: String!
    $locationId: Int
    $organizationId: Int
  ) {
    createDmsIntegration(
      active: $active
      companyId: $companyId
      dealershipId: $dealershipId
      dmsType: $dmsType
      locationId: $locationId
      organizationId: $organizationId
    ) {
      statusCode
      message
      dmsIntegration {
        id
        companyId
        locationId
        active
        dmsType
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_DMS_INTEGRATION = gql`
  mutation updateDmsIntegration(
    $active: Boolean
    $companyId: Int
    $dealershipId: Int
    $dmsType: String
    $integrationId: Int!
    $locationId: Int
    $organizationId: Int
  ) {
    updateDmsIntegration(
      active: $active
      companyId: $companyId
      dealershipId: $dealershipId
      dmsType: $dmsType
      integrationId: $integrationId
      locationId: $locationId
      organizationId: $organizationId
    ) {
      statusCode
      message
      dmsIntegration {
        companyId
        locationId
        departmentId
        dmsType
        organizationId
        dealershipId
        active
        credentials
        settings
        createdAt
        updatedAt
      }
    }
  }
`;

export const DELETE_DMS_INTEGRATION = gql`
  mutation deleteDmsIntegration($integrationId: Int!) {
    deleteDmsIntegration(integrationId: $integrationId) {
      statusCode
      message
    }
  }
`;

export const MOVE_LEAD_LOCATION = gql`
  mutation moveLeadLocation($leadId: Int!, $locationId: Int!, $assignedUserId: Int!) {
    moveLeadLocation(leadId: $leadId, locationId: $locationId, assignedUserId: $assignedUserId) {
      statusCode
      message
      lead {
        id
        fullName
        firstName
        lastName
        dateOfBirth
        leadSourceType
        leadSourceOriginalId
        companyId
        leadFileId
        crmIntegrationId
        status
        emailConsent
        emailConsentDate
        textConsent
        textConsentDate
        textConsentStatus
        otherSource
        leadStatusTypeId
        leadStatusType {
          id
          type
          status
        }
        emails {
          id
          leadId
          email
          emailType
        }
        phoneNumbers {
          id
          leadId
          phone
          phoneType
          lookupType
        }
        addresses {
          id
          leadId
          locationText
          addressLine1
          addressLine2
          city
          state
          postalCode
          country
        }
        vehicleOfInterest {
          id
          leadId
          year
          make
          model
          trim
          description
          budget
        }
        leadSource {
          id
          name
        }
        leadUsers {
          userType {
            id
            useCase
            name
          }
          user {
            id
            email
            firstName
            lastName
            companyRole {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const REASSIGN_LEAD_OPPORTUNITY = gql`
  mutation reassignLeadOpportunity(
    $reassignmentGroups: [OpportunityReassignmentInput]!
    $assignmentType: String!
    $assignedUserIds: [Int]
    $isTaskAssignment: Boolean
    $isAppointmentAssignment: Boolean
  ) {
    reassignLeadOpportunity(
      reassignmentGroups: $reassignmentGroups
      assignmentType: $assignmentType
      assignedUserIds: $assignedUserIds
      isTaskAssignment: $isTaskAssignment
      isAppointmentAssignment: $isAppointmentAssignment
    ) {
      statusCode
      message
    }
  }
`;

export const TRACK_MEDIA_ENGAGEMENT = gql`
  mutation TrackMediaEngagement(
    $mediaGalleryCode: String!
    $mmsObjectId: Int!
    $messageId: Int!
    $mediaType: String!
    $eventType: String!
    $playDuration: Int
  ) {
    trackMediaEngagement(
      mediaGalleryCode: $mediaGalleryCode
      mmsObjectId: $mmsObjectId
      messageId: $messageId
      mediaType: $mediaType
      eventType: $eventType
      playDuration: $playDuration
    ) {
      statusCode
      message
    }
  }
`;

// EAI-1486: admin impersonation. Start returns the target user so the FE can
// render the impersonated context; the FE then sends X-Impersonate-User on
// every request. Stop returns the admin's own user to restore context.
export const START_IMPERSONATION = gql`
  mutation StartImpersonation($targetUserId: Int!) {
    startImpersonation(targetUserId: $targetUserId) {
      statusCode
      message
      user {
        id
        email
        firstName
        lastName
        companyId
      }
    }
  }
`;

export const STOP_IMPERSONATION = gql`
  mutation StopImpersonation {
    stopImpersonation {
      statusCode
      message
      user {
        id
        email
        firstName
        lastName
        companyId
      }
    }
  }
`;
// Generic report schedule create/update/status/delete. Backing backend:
// WebApp-API report_schedule_api. Fields cover Daily/Weekly/Monthly cadences,
// recipients + CC, delivery mode (per_rep|combined), and one_shot (Email Now).

export const CREATE_REPORT_SCHEDULE = gql`
  mutation createReportSchedule(
    $name: String!
    $reportKey: String
    $scope: String
    $userIds: [Int]
    $locationId: Int
    $description: String
    $frequency: String
    $interval: Int
    $intervalUnit: String
    $runTime: String
    $timezone: String
    $dayOfWeek: [String]
    $dayOfMonth: Int
    $monthlyMode: String
    $monthlyWeekday: String
    $dateRangeType: String
    $customRangeStart: DateTime
    $customRangeEnd: DateTime
    $startDate: DateTime
    $endDate: DateTime
    $exportFormat: String
    $deliveryMethod: String
    $deliveryMode: String
    $emailSubject: String
    $emailBody: String
    $recipientUserIds: [Int]
    $recipientEmails: [String]
    $ccUserIds: [Int]
    $ccEmails: [String]
    $sendToSubject: Boolean
    $oneShot: Boolean
    $reportConfig: GenericScalar
  ) {
    createReportSchedule(
      name: $name
      reportKey: $reportKey
      scope: $scope
      userIds: $userIds
      locationId: $locationId
      description: $description
      frequency: $frequency
      interval: $interval
      intervalUnit: $intervalUnit
      runTime: $runTime
      timezone: $timezone
      dayOfWeek: $dayOfWeek
      dayOfMonth: $dayOfMonth
      monthlyMode: $monthlyMode
      monthlyWeekday: $monthlyWeekday
      dateRangeType: $dateRangeType
      customRangeStart: $customRangeStart
      customRangeEnd: $customRangeEnd
      startDate: $startDate
      endDate: $endDate
      exportFormat: $exportFormat
      deliveryMethod: $deliveryMethod
      deliveryMode: $deliveryMode
      emailSubject: $emailSubject
      emailBody: $emailBody
      recipientUserIds: $recipientUserIds
      recipientEmails: $recipientEmails
      ccUserIds: $ccUserIds
      ccEmails: $ccEmails
      sendToSubject: $sendToSubject
      oneShot: $oneShot
      reportConfig: $reportConfig
    ) {
      statusCode
      message
      reportSchedule {
        id
        name
        frequency
        runTime
        timezone
        deliveryMode
        status
        nextRunAt
      }
    }
  }
`;

export const UPDATE_REPORT_SCHEDULE = gql`
  mutation updateReportSchedule(
    $id: Int!
    $name: String
    $description: String
    $userIds: [Int]
    $locationId: Int
    $frequency: String
    $interval: Int
    $intervalUnit: String
    $runTime: String
    $timezone: String
    $dayOfWeek: [String]
    $dayOfMonth: Int
    $monthlyMode: String
    $monthlyWeekday: String
    $dateRangeType: String
    $customRangeStart: DateTime
    $customRangeEnd: DateTime
    $startDate: DateTime
    $endDate: DateTime
    $exportFormat: String
    $deliveryMode: String
    $emailSubject: String
    $emailBody: String
    $recipientUserIds: [Int]
    $recipientEmails: [String]
    $ccUserIds: [Int]
    $ccEmails: [String]
    $sendToSubject: Boolean
    $reportConfig: GenericScalar
  ) {
    updateReportSchedule(
      id: $id
      name: $name
      description: $description
      userIds: $userIds
      locationId: $locationId
      frequency: $frequency
      interval: $interval
      intervalUnit: $intervalUnit
      runTime: $runTime
      timezone: $timezone
      dayOfWeek: $dayOfWeek
      dayOfMonth: $dayOfMonth
      monthlyMode: $monthlyMode
      monthlyWeekday: $monthlyWeekday
      dateRangeType: $dateRangeType
      customRangeStart: $customRangeStart
      customRangeEnd: $customRangeEnd
      startDate: $startDate
      endDate: $endDate
      exportFormat: $exportFormat
      deliveryMode: $deliveryMode
      emailSubject: $emailSubject
      emailBody: $emailBody
      recipientUserIds: $recipientUserIds
      recipientEmails: $recipientEmails
      ccUserIds: $ccUserIds
      ccEmails: $ccEmails
      sendToSubject: $sendToSubject
      reportConfig: $reportConfig
    ) {
      statusCode
      message
      reportSchedule {
        id
        name
        status
        nextRunAt
      }
    }
  }
`;

export const SET_REPORT_SCHEDULE_STATUS = gql`
  mutation setReportScheduleStatus($id: Int!, $status: String!) {
    setReportScheduleStatus(id: $id, status: $status) {
      statusCode
      message
      reportSchedule {
        id
        status
        nextRunAt
      }
    }
  }
`;

export const DELETE_REPORT_SCHEDULE = gql`
  mutation deleteReportSchedule($id: Int!) {
    deleteReportSchedule(id: $id) {
      statusCode
      message
    }
  }
`;
